<template>
  <div>
    <el-container class="main-container">
      <el-header>
        <head_page :head_page_type=false ref="head_page"></head_page>
      </el-header>
      <el-main>
        <div id='choose_city'>
          <head_menu :has-back=true @go-back-click="goBack">
            <template #title>
              <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:10px;font-size: 20px;">
                {{chosen_city_shown}}
              </div>
            </template>

            <template #button-group-right>
              <el-button-group>
                <el-button @click="dialogFormVisible = true" :disabled="ifSave" class="hidden-md-and-down">
                  {{ $t('message.Save_Data') }}
                </el-button>
                <el-dialog :visible.sync="dialogFormVisible" class="hidden-md-and-down">
                  <el-form :model="form" @submit.native.prevent>
                    <el-form-item :label="$t('message.Client_name')" :label-width="formLabelWidth">
                      <el-input v-model="form.name" @keyup.enter.native = "onSubmit"></el-input>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">{{$t('message.Cancel')}}</el-button>
                    <el-button type="primary" @click="onSubmit">{{$t('message.OK')}}</el-button>
                  </div>
                </el-dialog>
                <el-badge :value="dataValueBadge" class="item">
                  <el-button style="margin-left: 10px;" @click="goHistory" :disabled = "dataSaved">{{ $t('message.History') }}
                  </el-button>
                </el-badge>

              </el-button-group>
            </template>
          </head_menu>
          <!--
          <div style="text-align: left;">
            <el-row>
              <el-col :span="8" style="background-color: #F0F0EE;">
                <el-button-group>
                  <el-button icon="el-icon-d-arrow-left" @click="goBack" style="background-color: #f3f3f4;" :disabled = "ifSave"></el-button>
                  <el-button icon="el-icon-s-home" @click="goHome" style="background-color: #e9e9ea;"></el-button>
                </el-button-group>
              </el-col>
              <el-col :span="6" style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:10px;font-size: 20px;">
                {{chosen_city_shown}}
              </el-col>
              <el-col :span="10" style="text-align: right;background-color: #F0F0EE;">
                <el-button-group>
                  <el-button @click="dialogFormVisible = true" :disabled="ifSave">
                    {{ $t('message.Save_Data') }}
                  </el-button>
                  <el-dialog :visible.sync="dialogFormVisible">
                    <el-form :model="form" @submit.native.prevent>
                      <el-form-item :label="$t('message.Client_name')" :label-width="formLabelWidth">
                        <el-input v-model="form.name" @keyup.enter.native = "onSubmit"></el-input>
                      </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">{{$t('message.Cancel')}}</el-button>
                      <el-button type="primary" @click="onSubmit">{{$t('message.OK')}}</el-button>
                    </div>
                  </el-dialog>
                  <el-badge :value="dataValueBadge" class="item">
                    <el-button @click="goHistory" :disabled = "dataSaved">{{ $t('message.History') }}
                    </el-button>
                  </el-badge>

                </el-button-group>
              </el-col>
            </el-row>
          </div>
          -->
          <div v-if="screenWidth>=992">
            <el-row style="margin-left: -10px; margin-right: -10px;" type="flex">
              <el-col :span="8" class="info-list-style" style="min-height:280px;padding-left:30px;" >

                <div style="text-align: left; margin-top: 10px" id ='selected_criterias'>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Gender')}}:</p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{gender}}</p>
                    </el-col>
                  </el-row>

                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Age')}}: </p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{age}}</p>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Spend_Power')}}: </p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{spend_power}}</p>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Interests')}}: </p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{interest}}</p>
                    </el-col>

                  </el-row>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.POI')}}: </p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{poi}}</p>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Media_Format')}}: </p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{media_type}}</p>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="margin:10px" v-if="ifShowViewed">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Rank')}}:</p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{rank}}</p>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Nearby_Location')}}:</p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{poi_ba_label_selection_list}}</p>
                    </el-col>
                  </el-row>
                </div>

              </el-col>
              
              
              <el-col :span="8" class="info-list-style" style="min-height:280px;
                            border-left:5px solid #EFEFEF;
                            border-right:5px solid #EFEFEF" >
                    <div style="background-color: white;margin:10px;height:40px;text-align:center">
                      <div style="padding: 5px;font-size: 18px;color:#254A6E;font-weight: 600;">
                        <span>{{$t('message.Campaign_Starting_Date')}} {{this.information.date.split('T')[0]}}</span>
                      </div>
                    </div>

              <div id='KPI1'>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <p class="p7">{{$t('message.Number_of_Bus_Lines')}}</p>
                  </el-col>
                  <el-col :span="8">
                    <p class="p7">{{$t('message.Number_of_Bus_Body')}}</p>
                  </el-col>
                  <el-col :span="8">
                    <p class="p7">{{$t('message.Duration(Months)')}}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="div_number">
                      <p class="p8">{{tableData[0].value}}</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div>
                      <p class="p8">{{tableData[1].value}}</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div>
                      <p class="p8">{{tableData[2].value}}</p>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 15px">
                  <el-col :span="l1">
                    <p class="p7">{{$t('message.Viewed_Impression')}}
                    </p>
                  </el-col>
                  <el-col :span="l2" v-if="ifShowViewed">
                    <p class="p7">{{$t('message.Viewed_Impression(Audience)')}}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="l1">
                    <div class="div_number">
                      <p class="p8" style="font-size: 24px;">{{tableData[4].value}}</p>
                    </div>
                  </el-col>
                  <el-col :span="l2">
                    <div>
                      <p class="p8" style="font-size: 24px;" v-if="ifShowViewed">{{tableData[5].value}}</p>
                    </div>
                  </el-col>
                </el-row>
              </div>
              </el-col>
              <el-col :span="8" class="info-list-style" style="min-height:280px;padding-right:30px;">
                
                    <el-row style="margin-top: 30px">
                      <el-col :span="12" v-if="pricingMode == 'media'">
                        <p class="p7">{{ $t("message.Media_Cost_RC_Discounted") }}</p>
                        <span class="p8" style="font-size: 14px">￥{{ media_cost }} / </span> 
                        <span class="p8" style="font-size: 18px">￥{{ media_discount_cost.toLocaleString() }}</span>
                      </el-col>
                      <el-col :span="12" v-else>
                        <p class="p7">{{ $t("message.Rate_Card_Media_Cost_1") }}</p>
                        <p class="p8">
                          ￥{{ media_cost }}
                        </p>
                      </el-col>
                      <el-col :span="12" v-if="pricingMode == 'media'">
                        <p class="p7" style="line-height: 3;">{{ $t("message.Production_Cost_1") }}</p>
                        <p class="p8">
                          ￥{{ production_cost }}
                        </p>
                      </el-col>
                      <el-col :span="12" v-else>
                        <p class="p7">{{ $t("message.Rate_Card_Production_Cost_1") }}</p>
                        <p class="p8">
                          ￥{{ production_cost }}
                        </p>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 20px">
                      <el-col :span="24" >
                        <p class="p7">
                          {{ $t("message.Proposal_Cost") }}
                          <el-popover placement="top-start" trigger="hover" >
                            <div>
                            　<span>{{$t('message.Proposal_Cost_Exp')}}</span>
                            </div>
                            <el-button icon="el-icon-info" circle slot="reference" style="border:0px; background-color: #F6F6F6;"></el-button>
                          </el-popover>
                        </p>
                        <p class="p8"  style="font-size: 22px">
                          ￥{{ proposal_discount_cost.toLocaleString() }}
                        </p>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-top: 20px">
                      <el-col :span="24" v-if="!ifShowViewed">
                          <p class="p7">
                            {{ $t("message.Proposal_CPM") }}
                          </p>
                          <p class="p8" style="font-size: 22px">￥{{ discount_proposal_CPM }}</p>
                      </el-col>
                      <el-col :span="24" v-if="ifShowViewed">
                          <p class="p7">
                            {{ $t("message.Proposal_CPM_Selection_And_Total") }}
                          </p>
                          <span class="p8" style="font-size: 22px">￥{{ discount_adjusted_proposal_CPM }} / </span> 
                          <span class="p8" style="font-size: 26px">￥{{ discount_proposal_CPM }}</span>
                      </el-col>
                    </el-row>
                <div id='KPI2'>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12" style="margin-top: 10px;padding-left:30px;padding-right:15px">
                <div class="level2_div2" id="chart_impression">
                  <div>
                    <bar-chart :chart-data="datacollection_impression_total" :options="chart_options_impression_total"></bar-chart>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" style="margin-top: 10px;padding-left:15px;padding-right:30px">
                <div class="level2_div2" id="chart_cpm">
                  <div>
                    <bar-chart :chart-data="datacollection_cpm" :options="chart_options_cpm"></bar-chart>
                  </div>
                </div>
              </el-col>
            </el-row>
            
            <div id='busTable'>
              <div class="table-style">
              <el-row >
                <el-table :data="hideColumnTableDataCommercial" fit style="width: 100%;" :header-row-style="{color:'#254A6E','font-weight':'bold','font-size':'1.2em'}"
                :row-style="rowStyle">
                  <el-table-column prop="bus_line_number" v-bind:label="$t('message.Bus_Lines')" align="center"> 
                  </el-table-column>
                  <el-table-column prop="duration" v-bind:label="$t('message.Duration2')" align="center">
                  </el-table-column>
                  <el-table-column prop="bus_quantity" v-bind:label="$t('message.Bus_Quantity')" align="center">
                  </el-table-column>
                  <el-table-column prop="price" v-bind:label="$t('message.Proposal_Cost') + '\n￥'" align="center" min-width="150">
                  </el-table-column>
                  <el-table-column prop="impression_total" v-bind:label="$t('message.Viewed_Impression()')" align="center" min-width="150">
                  </el-table-column>
                  <el-table-column v-if ="ifShowViewed" prop="adjusted_impression" v-bind:label="$t('message.Viewed_Impression(Audience)')" align="center" min-width="200">
                  </el-table-column>
                  <el-table-column prop="CPM" v-bind:label="$t('message.Proposal_CPM')+'\n￥'" align="center"  min-width="120">
                  </el-table-column>
                  <el-table-column v-if ="ifShowViewed" prop="adjusted_CPM" v-bind:label="$t('message.Proposal_CPM_cluster')+'\n￥'" align="center" min-width="120">
                  </el-table-column>
                </el-table>
              </el-row>
              
              </div>
              
              <el-row class="table-style">
                <el-col :span="12">
                  <div style="margin-right: 10px; background-color: white; padding-top: 20px" id="chart_index">
                    <p style="font-size:12px; text-align: left;font-weight: bolder; margin-left:20px; position: absolute">{{ $t("message.Index_Distribution_Chart") }}</p>
                    <apexchart class="heatmapchart"
                      ref="indexchart"
                      type="heatmap"
                      height="90"
                      width="100%"
                      :options="indexChartOptions"
                      :series="indexChartData"
                    ></apexchart>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div style="margin-left: 10px; background-color: white; padding-top: 20px" id="chart_rank">
                    <p style="font-size:12px; text-align: left;font-weight: bolder; margin-left:20px; position: absolute">{{ $t("message.Grade_Distribution_Chart") }}</p>
                    <apexchart class="heatmapchart"
                      ref="rankchart"
                      type="heatmap"
                      height="90"
                      width="100%"
                      :options="rankChartOptions"
                      :series="rankChartData"
                    ></apexchart>
                  </div>
                </el-col>
              </el-row>
<el-tabs v-model="activeTab">
      <el-tab-pane label="BAM表格" name="tab1">
              <el-row class="table-style">
                <!-- <el-table :data="hideColumnTableDataCommercial" fit style="width: 100%" :summary-method="getSummaries"
                  show-summary> -->
                <el-table :data="tableDataCommercial" fit style="width: 100%;"
                :row-class-name="tableRowClassName">
                  <el-table-column prop="bus_name" v-bind:label="$t('message.Bus_Line')">
                  </el-table-column>
                  <el-table-column prop="rate" v-bind:label="$t('message.index')">
                  </el-table-column>
                  <el-table-column prop="rank" v-bind:label="$t('message.Rank')">
                  </el-table-column>
                  <el-table-column v-if ="$i18n.locale=='en'" prop="media_type_label" v-bind:label="$t('message.Media_Format')" width="150">
                  </el-table-column>
                  <el-table-column v-if ="$i18n.locale=='cn'" prop="media_type_label" v-bind:label="$t('message.Media_Format')" width="150">
                  </el-table-column>
                  <el-table-column prop="bus_quantity" v-bind:label="$t('message.Bus_Quantity')" align="right">
                  </el-table-column>
                  <el-table-column prop="duration" v-bind:label="$t('message.Duration2')" align="right">
                  </el-table-column>
                  <!--
                  <el-table-column v-if="ifRankExists" prop="rate_card" v-bind:label="$t('message.Media_Cost')" align="right">
                  </el-table-column>
                  <el-table-column v-if="ifRankExists" prop="price" v-bind:label="$t('message.Total_Media_Cost')" align="right">
                  </el-table-column>
                  <el-table-column v-if="!ifRankExists" prop="impression_total" v-bind:label="$t('message.Viewed_Impression()')" align="right">
                  </el-table-column>
                  <el-table-column v-if ="ifShowViewed && !ifRankExists" prop="adjusted_impression" v-bind:label="$t('message.Viewed_Impression(Audience)')" align="right">
                  </el-table-column>
                  <el-table-column v-if="pricingMode=='proposal'" prop="discount_proposal_CPM" v-bind:label="$t('message.CPM')" align="right">
                  </el-table-column>
                  <el-table-column v-if ="pricingMode=='proposal' && ifShowViewed && !ifRankExists" prop="discount_adjusted_proposal_CPM" v-bind:label="$t('message.CPM_Target_Audience_Based')" align="right">
                  </el-table-column>
                  -->
                  <el-table-column prop="price" v-bind:label="$t('message.Total_Media_Cost_RC')" align="right">
                  </el-table-column>
                  <el-table-column prop="production_price" v-bind:label="$t('message.Total_Production_Cost_RC')" align="right">
                  </el-table-column>
                  <el-table-column prop="impression_total" v-bind:label="$t('message.Viewed_Impression()')" align="right">
                  </el-table-column>
                  <!-- <el-table-column prop="distinct_audience" v-bind:label="$t('message.Distinct_Audience')" align="right" v-if="false">
                  </el-table-column> -->
                  <el-table-column prop="distinct_audience" v-bind:label="$t('message.Distinct_Audience')" align="right" v-if="chosen_city=='Nanjing'|| chosen_city=='Chongqing'">
                  </el-table-column>
                  <el-table-column v-if="ifShowViewed" prop="adjusted_impression" v-bind:label="$t('message.Viewed_Impression(Audience)')" align="right">
                  </el-table-column>
                  <el-table-column v-if="pricingMode=='proposal'" prop="discount_proposal_CPM" v-bind:label="$t('message.CPM_Target_Audience_Based')" align="right">
                  </el-table-column>

                </el-table>
              </el-row>
              </el-tab-pane>
              
      <el-tab-pane label="HUB模板" name="tab2">
        <div id="hub_template">
        <el-table :data="tableDataCommercial" fit style="width: 100%;" :header-row-style="{color:'#254A6E','font-weight':'bold','font-size':'1.2em'}">
        <el-table-column prop="hub_city_code" label="城市Code">
                  </el-table-column>
        <el-table-column prop="hub_city_name_cn" label="城市">
                  </el-table-column>
         <el-table-column prop="hub_bus_id" label="巴士线路Code">
                  </el-table-column>
          <el-table-column prop="bus_name" label="巴士线路">
                  </el-table-column>
          <el-table-column prop="rank" label="线路级别">
                  </el-table-column>
          <el-table-column  prop="hub_media_format_code" label="发布形式细分Code" width="150">
                  </el-table-column>
          <el-table-column v-if ="$i18n.locale=='cn'" prop="media_type_label" label="发布形式细分" width="150">
                  </el-table-column>
          <el-table-column prop="bus_quantity" label="巴士台数" align="right">
                  </el-table-column>
        </el-table>
      </div>
      </el-tab-pane>
    </el-tabs>
            </div>
            <el-row :gutter="10" type="flex" justify="end" style="padding-right:25px;">
              <el-col :span="4">
                <el-input v-model="form.name" :placeholder="$t('message.Client_name')" :disabled = "ifSave">
                </el-input>
              </el-col>
              <el-upload action='localhost:8080/posts/' :on-change="handleUpload" :auto-upload="false" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG">
                <el-button slot="trigger">{{$t('message.Upload_logo')}}</el-button>
                <el-select v-model="exportType" :placeholder="$t('message.File_Type')">
                  <el-option 
                  v-for="item in exportTypeOptions" :key="item.value" :label="item.value" :value="item.value"> 
                  </el-option>
                </el-select>
                <!--<el-checkbox v-model="ifShowViewed" @change="changeDetailInfoView()" border>{{$t('message.Total_indicators')}}</el-checkbox>-->
                <el-button @click="exportTypeSelector()">{{$t('message.Export')}}</el-button>
              </el-upload>
            </el-row>

            <el-row :gutter="20" style="margin-top: 50px">
              <el-col :span="6">
                <div id="donut_gender">
                  <apexchart ref="donutGender" width="280" height="400" type="donut" :options="chartOptionsGender" :series="seriesGender"></apexchart>
                </div>
              </el-col>
              <el-col :span="18">
                <div>
                  <bar-chart :chart-data="datacollection_gender" :options="chart_options_gender" ></bar-chart>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" style="margin-top: 50px">
              <el-col :span="6">
                <div id="donut_age">
                  <apexchart ref="donutAge" width="300" height="400" type="donut" :options="chartOptionsAge" :series="seriesAge" ></apexchart>
                </div>
              </el-col>
              <el-col :span="18">
                <div>
                  <bar-chart :chart-data="datacollection_age" :options="chart_options_age"></bar-chart>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" style="margin-top: 50px">
              <el-col :span="6">
                <div id="donut_spend_power">
                  <apexchart ref="donutSpendPower" width="300" height="400" type="donut" :options="chartOptionsSpendPower" :series="seriesSpendPower" ></apexchart>
                </div>
              </el-col>
              <el-col :span="18">
                <div>
                  <bar-chart :chart-data="datacollection_spend_power" :options="chart_options_spend_power"></bar-chart>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" style="margin-top: 50px">
              <el-col :span="6">
                <div id="donut_interest">
                  <apexchart ref="donutInterest" width="300" height="400" type="donut" :options="chartOptionsInterest" :series="seriesInterest" ></apexchart>
                </div>
              </el-col>
              <el-col :span="18">
                <div>
                  <bar-chart :chart-data="datacollection_interest" :options="chart_options_interest"></bar-chart>
                </div>
              </el-col>
            </el-row>

            <el-row style="margin-top: 50px">
              <el-col :span="16" :offset="4">
                <div id='map'>
                  <div>
                    <mapf id='inside_map' ref="mapf" style="margin-top: 20px;margin-bottom: 20px;" :mapId="'amap-container'" isBusMap=true></mapf>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>

          <div v-if="screenWidth<992" style="background-color: white">
              <el-row :gutter=10 style="margin:0 -5px; padding:10px 0;">
                <el-col :xs="14" :sm="{span: 8, offset: 5}" :md="{span: 8, offset: 5}">
                  <el-input v-model="form.name" :placeholder="$t('message.Client_name')" :disabled = "ifSave">
                  </el-input>
                </el-col>
                <el-col :xs="10" :sm="4" :md="4">
                  <el-button  @click="onSubmit" :disabled="ifSave">
                    {{ $t('message.Save_Data') }}
                  </el-button>
                </el-col>
              </el-row>
            
            <el-collapse v-if="screenWidth<768" accordion>
              <el-collapse-item :title="$t('message.audience_info')">
                <el-form ref="form" label-width="40%">
                  <el-form-item :label="$t('message.Gender')">
                    {{gender}}
                  </el-form-item>
                  <el-form-item :label="$t('message.Age')">
                    {{age}}
                  </el-form-item>
                  <el-form-item :label="$t('message.Spend_Power')">
                    {{spend_power}}
                  </el-form-item>
                  <el-form-item :label="$t('message.Interests')">
                    {{interest}}
                  </el-form-item>
                  <el-form-item v-if="poi" :label="$t('message.POI')">
                    {{poi}}
                  </el-form-item>
                  <el-form-item :label="$t('message.Media_Format')">
                    {{media_type}}
                  </el-form-item>
                  <el-form-item v-if="ifShowViewed && rank" :label="$t('message.Rank')">
                    {{rank}}
                  </el-form-item>
                  <el-form-item v-if="poi_ba_label_selection_list" :label="$t('message.Nearby_Location')">
                    {{poi_ba_label_selection_list}}
                  </el-form-item>
                </el-form>
              </el-collapse-item>
              <el-collapse-item :title="$t('message.campaign_info')">
                <el-form ref="form" label-width="60%">
                  <el-form-item :label="$t('message.Campaign_Starting_Date')">
                    {{this.information.date.split('T')[0]}}
                  </el-form-item>
                  <el-form-item :label="$t('message.Duration(Months)')">
                    {{tableData[2].value}}
                  </el-form-item>
                  <el-form-item :label="$t('message.Number_of_Lines_And_Bus')">
                    {{tableData[0].value}} / {{tableData[1].value}}
                  </el-form-item>
                  <el-form-item v-if="!ifShowViewed" :label="$t('message.Viewed_Impression')">
                    {{tableData[4].value}}
                  </el-form-item>
                  <el-form-item v-if="ifShowViewed" :label="$t('message.Viewed_Impression_Total_And_Selection')">
                    {{intToString(tableData[4].value)}} / {{intToString(tableData[5].value)}}
                  </el-form-item>
                  <el-form-item :label="$t('message.Total_Media_Cost_1')">
                    ￥{{estimated_cost}}
                  </el-form-item>
                  <el-form-item v-if="!ifShowViewed" :label="$t('message.Gross_CPM_1')">
                    ￥{{CPM}}
                  </el-form-item>
                  <el-form-item v-if="ifShowViewed" :label="$t('message.CPM_Total_And_Selection')">
                    ￥{{CPM}} / ￥{{adjusted_CPM}}
                  </el-form-item>
                </el-form>
              </el-collapse-item>
            </el-collapse>

            <el-row v-if="screenWidth>=768" style="margin-top: 10px;">
              <el-col :span=12>
                <el-card class="box-card" shadow="never">
                  <div slot="header" class="clearfix">
                    <span>{{$t('message.audience_info')}}</span>
                  </div>

                  <div>
                    <el-form ref="form" label-width="40%" style="min-height: 120px">
                      <el-form-item :label="$t('message.Gender')">
                        {{gender}}
                      </el-form-item>
                      <el-form-item :label="$t('message.Age')">
                        {{age}}
                      </el-form-item>
                      <el-form-item :label="$t('message.Spend_Power')">
                        {{spend_power}}
                      </el-form-item>
                      <el-form-item :label="$t('message.Interests')">
                        {{interest}}
                      </el-form-item>
                      <el-form-item v-if="poi" :label="$t('message.POI')">
                        {{poi}}
                      </el-form-item>
                      <el-form-item :label="$t('message.Media_Format')">
                        {{media_type}}
                      </el-form-item>
                      <el-form-item v-if="ifShowViewed && rank" :label="$t('message.Rank')">
                        {{rank}}
                      </el-form-item>
                      <el-form-item v-if="poi_ba_label_selection_list" :label="$t('message.Nearby_Location')">
                        {{poi_ba_label_selection_list}}
                      </el-form-item>
                    </el-form>
                  </div>
                </el-card>
              </el-col>
              <el-col :span=12>
                <el-card class="box-card" shadow="never">
                  <div slot="header" class="clearfix">
                    <span>{{$t('message.campaign_info')}}</span>
                  </div>

                  <div>
                    <el-form ref="form" label-width="60%">
                      <el-form-item :label="$t('message.Campaign_Starting_Date')">
                        {{this.information.date.split('T')[0]}}
                      </el-form-item>
                      <el-form-item :label="$t('message.Duration(Months)')">
                        {{tableData[2].value}}
                      </el-form-item>
                      <el-form-item :label="$t('message.Number_of_Lines_And_Bus')">
                        {{tableData[0].value}} / {{tableData[1].value}}
                      </el-form-item>
                      <el-form-item v-if="!ifShowViewed" :label="$t('message.Viewed_Impression')">
                        {{tableData[4].value}}
                      </el-form-item>
                      <el-form-item v-if="ifShowViewed" :label="$t('message.Viewed_Impression_Total_And_Selection')">
                        {{intToString(tableData[4].value)}} / {{intToString(tableData[5].value)}}
                      </el-form-item>
                      <el-form-item :label="$t('message.Total_Media_Cost_1')">
                        ￥{{estimated_cost}}
                      </el-form-item>
                      <el-form-item v-if="!ifShowViewed" :label="$t('message.Gross_CPM_1')">
                        ￥{{CPM}}
                      </el-form-item>
                      <el-form-item v-if="ifShowViewed" :label="$t('message.CPM_Total_And_Selection')">
                        ￥{{CPM}} / ￥{{adjusted_CPM}}
                      </el-form-item>
                    </el-form>
                  </div>
                </el-card>
              </el-col>
            </el-row>

            <el-col :span="24" >
              <div style="margin: 20px 0 5px 0;">
                <bar-chart :style="{height:'300px'}" :chart-data="datacollection_impression_total" :options="chart_options_impression_total"></bar-chart>
              </div>
            </el-col>

            <el-col :span="24" >
              <div style="margin: 20px 0 5px 0;">
                <bar-chart :style="{height:'300px'}" :chart-data="datacollection_cpm" :options="chart_options_cpm"></bar-chart>
              </div>
            </el-col>

            <el-col :span="24" >
              <el-table v-if="!ifShowViewed || screenWidth<768" :data="tableDataCommercial" fit border style="width: 100%; margin-top: 20px; font-size: 12px;"
                :row-class-name="tableRowClassName">
                <el-table-column prop="bus_name" v-bind:label="$t('message.Bus_Line')" min-width="20%">
                </el-table-column>
                <el-table-column prop="rate" v-bind:label="$t('message.index2')" align="center" min-width="15%">
                </el-table-column>
                <el-table-column prop="bus_quantity" v-bind:label="$t('message.Bus_Quantity')" align="center" min-width="15%">
                </el-table-column>
                <el-table-column prop="impression_total" v-bind:label="$t('message.Viewed_Impression()')" align="right" min-width="25%">
                </el-table-column>
                <el-table-column prop="CPM" v-bind:label="$t('message.CPM')" align="right" min-width="25%">
                </el-table-column>
              </el-table>

              <el-table v-if="ifShowViewed && screenWidth>=768" :data="tableDataCommercial" fit border style="width: 100%; margin-top: 20px; font-size: 12px;"
                :row-class-name="tableRowClassName">
                <el-table-column prop="bus_name" v-bind:label="$t('message.Bus_Line')" min-width="10%">
                </el-table-column>
                <el-table-column prop="rate" v-bind:label="$t('message.index2')" align="center" min-width="10%">
                </el-table-column>
                <el-table-column prop="bus_quantity" v-bind:label="$t('message.Bus_Quantity')" align="center" min-width="10%">
                </el-table-column>
                <el-table-column prop="impression_total" v-bind:label="$t('message.Viewed_Impression()')" align="right" min-width="17%">
                </el-table-column>
                <el-table-column prop="adjusted_impression" v-bind:label="$t('message.Viewed_Impression(Audience)')" align="right" min-width="17%">
                </el-table-column>
                <el-table-column prop="CPM" v-bind:label="$t('message.CPM')" align="right" min-width="18%">
                </el-table-column>
                <el-table-column prop="adjusted_CPM" v-bind:label="$t('message.CPM_Target_Audience_Based')" align="right" min-width="18%">
                </el-table-column>
                <el-table-column prop="distinct_audience" v-bind:label="$t('message.Distinct_Audience')" align="right" min-width="17%" v-if="chosen_city=='Nanjing'|| chosen_city=='Chongqing'">
                </el-table-column>
              </el-table>
            </el-col>

            <el-col :span="24">
              <div style="margin: 20px 0 5px 0;">
                <apexchart ref="donutGender" height="300" type="donut" :options="chartOptionsGender" :series="seriesGender" ></apexchart>
              </div>
            </el-col>

            <el-col :span="24">
              <div style="margin: 20px 0 5px 0;">
                <apexchart ref="donutAge" height="300" type="donut" :options="chartOptionsAge" :series="seriesAge" ></apexchart>
              </div>
            </el-col>

            <el-col :span="24">
              <div style="margin: 20px 0 5px 0;">
                <apexchart ref="donutSpendPower" height="300" type="donut" :options="chartOptionsSpendPower" :series="seriesSpendPower" ></apexchart>
              </div>
            </el-col>

            
            <el-col :span="24">
              <div style="margin: 20px 0 5px 0;">
                <apexchart ref="donutInterest" height="350" type="donut" :options="chartOptionsInterest" :series="seriesInterest" ></apexchart>
              </div>
            </el-col>

            <el-col :span="24">
              <div style="padding-top: 50px">
              </div>
            </el-col>

            <el-col :span="24" >
              <div id='map'>
                <div>
                  <mapf ref="mapf" style="margin: 10px 0;" :mapId="'amap-container'" isBusMap=true></mapf>
                </div>
              </div>
            </el-col>
          </div>

        </div>
      </el-main>
    </el-container>
    <export_pdf ref="export_pdf"></export_pdf>
  </div>
</template>

<script>
  import head_page from './components/head_page.vue';
  import head_menu from './components/head_menu.vue';
  import export_pdf from './components/exportPdf.vue';
  import axios from 'axios';
  import _global from './components/global.vue';
  import BarChart from './components/BarChart.js';
  import DoughnutChart from './components/DoughnutChart.js';
  import chartjsPluginAnnotation from "chartjs-plugin-annotation";
  import exportPdf from "./components/exportPdf.js";
  import exportExcel from "./components/exportExcel.js";
  import exportHubTemplateExcel from "./components/exportHubTemplateExcel.js";
  import mapf from './mapf.vue'
  import parseUtil from './utils/parseUtils.vue'
  import * as _ from 'lodash'
  import HorizontalBarChart from './components/HorizontalBarChart.js';
  import LineChart from './components/LineChart.js';

  var row_table = {
    "bus_id": 0,
    "media_type_label": "",
    "rate_card": 0,
    "production_cost": 0,
    "bus_quantity": 0,
    "duration": 0,
    "impression_total": 0,
    "price": 0,
    "CPM": 0,
    "reach": 0,
    "frequency": 0,
  };
  export default {
    name: 'board',
    mixins: [parseUtil],
    data() {
      return {
        tableData: [{
          title: this.$t('message.Number_of_Bus_Lines'),
          value: ""
        }, {
          title: this.$t('message.Number_of_Bus_Body'),
          value: ""
        }, {
          title: this.$t('message.Duration'),
          value: ""
        }, {
          title: this.$t('message.Audience_Reach'),
          value: ""
        }, {
          title: this.$t('message.Viewed_Impression'),
          value: ""
        }, {
          title: this.$t('message.Viewed_Impression_Selection_Based'),
          value: ""
        }, {
          title: this.$t('message.Frequency'),
          value: ""
        }, ],
        estimated_cost: "",
        CPM: "",
        adjusted_CPM: "",
        media_cost: "",
        production_cost: "",
        proposal_cost: "",
        media_discount: 100,
        production_discount: 100,
        proposal_discount: 100,
        media_discount_cost: "",
        production_discount_cost: "",
        proposal_discount_cost: "",
        media_CPM: 0,
        adjusted_media_CPM: 0,
        discount_media_CPM: 0,
        discount_adjusted_media_CPM: 0,
        proposal_CPM: 0,
        adjusted_proposal_CPM: 0,
        discount_proposal_CPM: 0,
        discount_adjusted_proposal_CPM: 0,
        pricingMode: false,

        bus_id_arr: [],
        options: null,
        information: {
          value_duration:1,
          date:'T'
        },
        gender: null,
        age: null,
        spend_power: null,
        interest: null,
        poi: null,
        media_type: null,
        rank: null,
        lang: 'en',
        chosen_city: "",
        tableDataCommercial: [row_table, ],
        total_objects: null,
        datacollection_reach: {},
        datacollection_frequency: {},
        datacollection_impression_total: {},
        datacollection_price: {},
        datacollection_cpm: {},
        chart_options_impression_total: {},
        chart_options_price: {},
        chart_options_cpm: {},
        ifShowViewed: true,
        dialogFormVisible: false,
        form: {
          name: ''
        },
        formLabelWidth: '120px',
        clientLogoImage:'',
        clientLogoImg: '',
        campaignDate:'',
        campaignDuration:'1',
        dataValueBadge:0,
        exportTypeOptions: [{value:'PDF'},{value:'Excel'},{value:'Hub Template'}],
        exportType:'',
        reference_id:'',
        createdBy:'',
        team:'',
        media_format_options : [],
        rank_options : [],
        dataHistory:'',
        flag: false,
        ifSave: false,
        impression_datasets:[],
        impression_annotations:[],
        cpm_datasets:[],
        cpm_annotations:[],
        responseSaveData:true,
        datacollection_gender:{},
        datacollection_age:{},
        datacollection_spend_power:{},
        datacollection_interest:{},
        seriesGender:[],
        seriesAge:[],
        seriesSpendPower:[],
        seriesInterest:[],
        chart_options_gender: {},
        chart_options_age: {},
        chart_options_spend_power: {},
        chart_options_interest: {},
        chartOptionsGender:{},
        chartOptionsAge:{},
        chartOptionsSpendPower:{},
        chartOptionsInterest:{},
        dataSaved: true,
        ifRank:false,
        poi_ba_label_selection_list:[],
        poi_ba_value_selection_list:[],
        related_poi_nb_summary:null,
        totalNearbyBusNumber : 0,
        screenWidth: window.innerWidth,
        timeoutId: "",
        flag_nanjing_data_v2:true,
        flag_wuhan_data_v2:true,
        flag_chongqing_data_v3:true,  // TODO: 重庆v3 coverage指标 - 在此行后添加重庆v3 flag
        indexChartData: [
          {
            name: "Series 1",
            data: [
              {
                x: "50",
                y: 0,
              },
              {
                x: "60",
                y: 0,
              },
              {
                x: "70",
                y: 0,
              },
              {
                x: "80",
                y: 0,
              },
              {
                x: "90",
                y: 0,
              },
              {
                x: "100",
                y: 0,
              },
              {
                x: "110",
                y: 0,
              },
              {
                x: "120",
                y: 0,
              },
              {
                x: "130",
                y: 0,
              },
              {
                x: "140",
                y: 0,
              },
            ],
          },
        ],
        rankChartData: [
          {
            name: "Series 1",
            data: [
              {
                x: "S",
                y: 0,
              },
              {
                x: "A++",
                y: 15,
              },
              {
                x: "A+",
                y: 4,
              },
              {
                x: "A",
                y: 5,
              }
            ],
          },
        ],
        indexChartOptions: {
          grid: {
            show: true,
          },
          chart: {
            type: "heatmap",
            toolbar: {
              show: false,
            },
          },
          xaxis: {
            type: "category",
            categories: ["50-60", "61-70", "71-80", "81-90", "91-100", "101-110", "111-120", "121-130", "131-140", "141-150"],
            labels: {
              show: true,
            },
            tooltip: {
              enabled: false,
            }
          },
          yaxis: {
            labels: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          inverseOrder: true,
          tooltip: {
            enabled: true,
            x: {
              show: false,
            },
            y: {
              show: false,
              title: {
                formatter: function (value, {series, seriesIndex, dataPointIndex, w}) {
                  let index = dataPointIndex*10 + 50
                  let text = index.toString() + ' - ' + (index+10).toString() + ' : '
                  return  text;
                },
              },
            },
            fixed:{
              enabled:true,
              position:'topRight'
            }
          },
          colors: ["#008FFB"],
          plotOptions: {
            heatmap: {
              colorScale: {
              ranges: [
                {
                  from: 0,
                  to: 1,
                  color: '#c4e6ff'
                },
              ]
            }
            }
          },        
        },
        rankChartOptions: {
          grid: {
            show: true,
          },
          chart: {
            type: "heatmap",
            toolbar: {
              show: false,
            },
          },
          xaxis: {
            type: "category",
            categories: ["S","A++","A+","A"],
            labels: {
              show: true,
            },
            tooltip: {
              enabled: false,
            }
          },
          yaxis: {
            labels: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          inverseOrder: true,
          tooltip: {
            enabled: true,
            x: {
              show: false,
            },
            y: {
              show: false,
              title: {
                formatter: function (value, {series, seriesIndex, dataPointIndex, w}) {
                  let text = ""
                  switch (dataPointIndex) {
                    case 0:
                      text = "S: "
                      break;
                    case 1:
                      text = "A++: "
                      break;
                    case 2:
                      text = "A+: "
                      break;
                    case 3:
                      text = "A: "
                      break;
                  }
                  return text;
                },
              },
            },
            fixed:{
              enabled:true,
              position:'topRight'
            },
          },
          colors: ["#008FFB"],
          plotOptions: {
            heatmap: {
              colorScale: {
              ranges: [
                {
                  from: 0,
                  to: 1,
                  color: '#c4e6ff'
                },
              ]
            }
            }
          }
          
        },
        activeTab: 'tab1',
      }
    },
    created() {
      document.title = 'Data Board';
      window.addEventListener("resize", this.resizeHandler);
    },
    mounted() {
      this.chosen_city = this.$route.query.chosen_city
      this.$refs.head_page.update_user_name()
      this.lang = JSON.parse(sessionStorage.getItem('lang'))
      this.$i18n.locale = this.lang
      this.$refs.head_page.switchLang(this.lang)
      this.getReportLength()
      let data = JSON.parse(sessionStorage.getItem('Data_History'))
      if (data && data.reference_id)
        this.reference_id = data.reference_id
      if(data!=undefined){
        if(data.form!=undefined){
          this.form = data.form
        }
      }
      if (this.chosen_city != undefined){
        
        //正常流程
        this.getV2Dataflag()
        this.fillData()
        this.fillData_Options()
        this.fillData_Info()
        this.fillData_Map(false)
        this.fillTable()
        this.total_objects = sessionStorage.getItem('total_objects')
      }else{
        //查看历史
        this.ifSave = true
        this.fromHistoryAction()
      }
      this.showBusLine()
    },
    computed:{
      l1: function(){
        return this.ifShowViewed?12:24
      },
      l2: function(){
        return this.ifShowViewed?12:0
      },
      chosen_city_shown: function() {
      
        let tmp = "message." + this.chosen_city
        return this.$t(tmp)
      },
      ifRankExists: function(){
        return !(this.rank=='' || this.rank==null)
      },
      hideColumnTableDataCommercial: function(){
         let a = this.tableDataCommercial
         let tmp = this.getSummaries()
         return tmp
      },
      localLang() {
        return this.$i18n.locale;
      }
    },
    methods: {
      rowStyle({ row, rowIndex}) {
        return {'font-weight':'bold','font-size':'1.5em','height':'2em'}
      
    },

      tableRowClassName({row, rowIndex}) {
        return 'table-rows';
      },
      fromHistoryAction(){
        //说明数据是从history来的
        this.dataHistory = JSON.parse(sessionStorage.getItem('Data_History'))
        this.chosen_city = this.dataHistory.city
        sessionStorage.setItem('tableDataCommercial', JSON.stringify(this.dataHistory.bus_line))
        sessionStorage.setItem('Data_Options', JSON.stringify(this.dataHistory.options))
        this.fillData_Map(true)
        this.fillTable()
        this.estimated_cost = this.dataHistory.estimated_cost.toLocaleString()
        this.CPM = this.dataHistory.CPM
        this.adjusted_CPM = this.dataHistory.adjusted_CPM
        this.ifShowViewed = this.changeBooleanInverse(this.dataHistory.ifShowViewed)
        this.form = this.dataHistory.form

        this.fillData_Options()
        let obj={}
        obj.data_audience=this.dataHistory.data_audience
        obj.data_poi = this.changeBooleanInverse(this.dataHistory.data_poi)
        let obj2={}
        obj2.value_media_format = this.dataHistory.data_media
        obj2.value_rank = this.dataHistory.data_rank
        obj.data_media_rank = obj2
        obj.campaignDate =this.dataHistory.date
        obj.date =this.dataHistory.date
        if (this.numberBit(obj.date)==10){
          obj.date = obj.date*1000
        }
        let tmp = new Date(obj.date)
        obj.date = tmp.toISOString()
        obj.campaignDuration = this.dataHistory.duration
        obj.poi_ba_label_selection_list = this.dataHistory.options.poi_ba_label_selection_list
        obj.poi_ba_value_selection_list = this.dataHistory.options.poi_ba_value_selection_list
        sessionStorage.setItem('Data_Information', JSON.stringify(obj))
        this.getV2Dataflag()
        this.fillData_Info()
        this.tableData = this.dataHistory.tableData
        
        this.fillData()
      },
      onSubmit() {
        if (this.form.name == "" || this.form.name == null){
          this.openNotice3()
          this.dialogFormVisible = false
          return false
        }else{
          this.messageSaveData()
          this.dialogFormVisible = false
          return true
        }
      },
      openNotice3() {
        var _self = this;
        this.$notify({
          message: _self.$t('message.Please_enter_the_client_name'),
          position: 'top-left',
          duration: 2000
        });
      },
      getReportLength() {
        let api_url = _global.serverSrc + '/report_length/' + '?format=json';
        let obj = new Object()
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.report_length) {
              this.dataValueBadge = response.data.report_length[0].report_number
            }
          })
          .catch(function(error) {});
      },
      
      async messageSaveData(){
        if (this.ifSave == true){
          //edit 状态不保存
          return
        }
        await this.$confirm( this.$t('message.Do_you_want_to_save_data_you_made'), 'Info', {
          confirmButtonText: this.$t('message.OK'),
          cancelButtonText: this.$t('message.Cancel'),
          type: 'warning'
        }).then(async() => {
          await this.saveData()
          this.$message({
            type: 'success',
            message: this.$t('message.Data_is_saved')
          });
          this.responseSaveData = true
        }).catch(e => {
          this.$message({
            type: 'info',
            message: this.$t('message.Cancelled')
          });
          this.responseSaveData = false
        });
      },
      async saveData() {
        let obj = new Object()
        let dataInformation = JSON.parse(sessionStorage.getItem('Data_Information'))
        obj.data_audience = dataInformation.data_audience
        obj.data_poi = this.changeBoolean(dataInformation.data_poi)
        obj.data_media = dataInformation.data_media_rank.value_media_format
        obj.data_rank = dataInformation.data_media_rank.value_rank 
        obj.tableData = this.tableData
        obj.form = this.form
        obj.bus_line = this.tableDataCommercial
        obj.CPM=this.CPM
        obj.adjusted_CPM=this.adjusted_CPM
        let data = JSON.parse(sessionStorage.getItem('Data_Information'))
        if (data.value_duration != null){
          obj.duration = data.value_duration
        }else{
          obj.duration = data.campaignDuration
        }
        if (data.date != null){
          let tmp = data.date.split('T')[0].split('-')
          let date = Date.UTC(tmp[0],tmp[1]-1,tmp[2])
          obj.date = Math.round(date / 1000)
        }else{
          obj.date = data.campaignDate
        }
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.estimated_cost = this.estimated_cost
        obj.data_map = JSON.parse(sessionStorage.getItem('Data_Map'))
        delete obj.data_map.ifShowViewed
        obj.viewed_impression = this.delcommafy(this.tableData[4].value)
        obj.city = this.chosen_city
        obj.options={}
        obj.options.audience_options = this.options.audience_options
        obj.options.media_rank_options = this.options.media_rank_options
        let dataMap =  JSON.parse(sessionStorage.getItem('Data_Map'))
        if (dataMap !=null){
          obj.ifShowViewed = this.changeBoolean(dataMap.ifShowViewed)
        }else{
          obj.ifShowViewed = this.changeBoolean(this.ifShowViewed)
        }
        obj.bus_id_arr = JSON.parse(sessionStorage.getItem('bus_id_arr'))
        if (obj.bus_id_arr == null){
          obj.bus_id_arr=[]
          for (let ele of obj.bus_line){
            obj.bus_id_arr.push(ele.bus_name)
          }
        }
        obj.options.poi_ba_value_selection_list = data['poi_ba_value_selection_list']
        obj.options.poi_ba_label_selection_list = data['poi_ba_label_selection_list']
        let api_url = _global.serverSrc + '/user_upload/?format=json'
        return await this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.upload_check[0].is_ok == 1) {
              //传成功了
              this.reference_id = response.data.upload_check[0].reference_id
              this.dataSaved = false
              this.openNotice()
            } else {
              //失败了
              this.openNotice2()
            }
          })
          .catch(e => {
          })
        this.dialogFormVisible = false

      },
      changeBoolean(data_poi){
        if (data_poi == false){
          data_poi = 0
        } else if (data_poi == true){
          data_poi =1
        }else{
          for (let ele in data_poi){
            if (data_poi[ele] == true){
              data_poi[ele] = 1
            }else{
              data_poi[ele] = 0
            }
          }
        }
        return data_poi
      },
      changeBooleanInverse(data_poi){
        if (data_poi == 0){
          data_poi = false
        } else if (data_poi == 1){
          data_poi = true
        }else{
          for (let ele in data_poi){
            if (data_poi[ele] == 1){
              data_poi[ele] = true
            }else{
              data_poi[ele] = false
            }
          }
        }
        return data_poi
      },
      openNotice() {
        var _self = this;
        this.$notify({
          message: _self.$t('message.The_data_is_successfully_uploaded'),
          position: 'top-left'
        });
      },
      openNotice2() {
        var _self = this;
        this.$notify({
          message: _self.$t('message.The_data_is_failed_to_upload'),
          position: 'top-left'
        });
      },
      handleUpload(file){
        this.clientLogoImage=file.raw

        let FR = new FileReader();
        FR.readAsDataURL(this.clientLogoImage);
        FR.onload=()=>{
          this.clientLogoImage=FR.result
        }
      },
      goHistory() {
        this.$router.push('./history')
      },
      delcommafy(num) {
        if (typeof num == 'number') {
          return num
        }else if (num != '' && num !=null ){
          num = num.replace(/,/g, '')
        }else{
          num = 0
        }
        return Number(num)
      },
      getSummaries() {
        let sums_with_target_audience = []
        let sums_without_target_audience = []
        let sumMonth = 0
        let sumQuantity = 0
        let sumCPM = 0
        let sumImpression = 0
        let sumPrice = 0
        let avgCPM = 0
        let sumAdjustedImpression = 0
        let avgAdjustedCPM = 0
        let avgMonth = 0
        if (this.tableDataCommercial.length > 0 && this.tableDataCommercial[0].bus_id != 0) {
          this.tableDataCommercial.forEach((column, index) => {
            const price = Number(this.delcommafy(column.price))
            const productionCost = Number(this.delcommafy(column.production_cost || 0))
            const adjustedImpression = Number(this.delcommafy(column.adjusted_impression))
            sumQuantity = column.bus_quantity + sumQuantity
            sumMonth = column.duration + sumMonth
            sumCPM = Number(column.CPM) + sumCPM
            sumImpression = Number(this.delcommafy(column.impression_total)) + sumImpression
            sumPrice = price + productionCost + sumPrice
            sumAdjustedImpression = adjustedImpression + sumAdjustedImpression
          })
          avgCPM = (sumPrice / sumImpression * 1000).toFixed(2)
          avgAdjustedCPM = (sumPrice / sumAdjustedImpression * 1000).toFixed(2)
          
          avgMonth = sumMonth/this.tableDataCommercial.length
        }
        sums_with_target_audience = ['', '', '', sumQuantity, avgMonth, '', sumPrice.toLocaleString(), sumImpression.toLocaleString(),sumAdjustedImpression.toLocaleString(),
                  avgCPM,avgAdjustedCPM
                ]
        sums_without_target_audience = ['', '', '', sumQuantity, avgMonth, '', sumPrice.toLocaleString(), sumImpression.toLocaleString(),
                  avgCPM
                ]
        let tmp=[]
        tmp[0] = {
            'bus_quantity':sumQuantity,
            'duration':avgMonth,
            'price': this.proposal_discount_cost.toLocaleString(),
            'impression_total':sumImpression.toLocaleString(),
            'adjusted_impression':sumAdjustedImpression.toLocaleString(),
            'CPM': this.discount_proposal_CPM,
            'adjusted_CPM': this.discount_adjusted_proposal_CPM,
            'bus_line_number': this.tableDataCommercial.length
        }
        return tmp
      },

      goHome: function() {
        this.$router.push({
          path: '/choose_city'
        });
        let lang = JSON.parse(sessionStorage.getItem("lang"));
        let user = JSON.parse(sessionStorage.getItem("User"));
        let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
        sessionStorage.clear();
        sessionStorage.setItem("lang", JSON.stringify(lang));
        sessionStorage.setItem("User", JSON.stringify(user));
        sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
      },
      goBack: function(event) {
        if (this.$route.query.back_url) {
          this.$router.push({
            path: this.$route.query.back_url, //go back to history
            query: {
              back_url: '/choose_city'
            }
          })
        }
        else {
          this.$router.push({
            path: '/map',
            query: {
              chosen_city: this.$route.query.chosen_city
            }
          })
        }
      },

      transDataOfTableData(tableData1, tableData2) {
        for (let i = 0; i < tableData1.length; i++) {
          tableData1[i].value = tableData2[i].value;
        }
      },
      fillTable() {
        this.tableDataCommercial = JSON.parse(sessionStorage.getItem('tableDataCommercial'))
        this.tableDataCommercial.forEach((item, index) => {
  this.tableDataCommercial[index].rate_card = item.rate_card.toLocaleString()
  this.tableDataCommercial[index].production_cost = item.production_cost .toLocaleString()
  this.tableDataCommercial[index].impression_total = item.impression_total .toLocaleString()
  this.tableDataCommercial[index].budget = item.budget .toLocaleString()
  this.tableDataCommercial[index].price = item.price .toLocaleString()
  this.tableDataCommercial[index].production_price = item.production_price .toLocaleString()
  this.tableDataCommercial[index].adjusted_impression = item.adjusted_impression.toLocaleString()
  this.tableDataCommercial[index].discount_proposal_CPM = (Number(item.proposal_CPM*this.proposal_discount/100).toFixed(2)).toLocaleString()
  this.tableDataCommercial[index].discount_adjusted_proposal_CPM = (Number(item.adjusted_proposal_CPM)*this.proposal_discount/100).toFixed(2).toLocaleString()
  this.tableDataCommercial[index].distinct_audience = item.distinct_audience.toLocaleString()
  // this.tableDataCommercial[index].hub_bus_id = item.hub_bus_id != null ? item.hub_bus_id.toLocaleString() : ''
  // this.tableDataCommercial[index].hub_media_format_code = item.hub_media_format_code != null ? item.hub_media_format_code.toLocaleString() : ''
  // this.tableDataCommercial[index].hub_city_code = item.hub_city_code != null ? item.hub_city_code.toLocaleString() : ''
  // this.tableDataCommercial[index].hub_city_name_cn = item.hub_city_name_cn != null ? item.hub_city_name_cn.toString() : ''
  if (this.$i18n.locale == 'cn'){
    this.tableDataCommercial[index].media_type_label = item.media_type_label_cn
  }
  if(this.tableDataCommercial[index].hasOwnProperty("related_poi_nb")){
    if(this.tableDataCommercial[index].related_poi_nb != 0){
      this.totalNearbyBusNumber += 1
    }
  }
})
        this.tableDataCommercial = [...this.tableDataCommercial]



      },
      fillData_Options() {
        this.options = JSON.parse(sessionStorage.getItem('Data_Options'))
      },
      numberBit(n){
        let b =0
        while (n>0){
          n=Math.floor(n/10)
          b=b+1
        }
        return b
      },
      getV2Dataflag(){
        let start_date = new Date(this.getCampaignDate())
        let change_date_nj = new Date('2023-3-1')
        let change_date_wh = new Date('2023-8-28')
        let change_date_cq = new Date('2026-3-1')
        this.flag_chongqing_data_v3 = (this.chosen_city == "Chongqing") && (start_date > change_date_cq)
        this.flag_nanjing_data_v2 = (this.chosen_city == "Nanjing") &&(start_date > change_date_nj)
        this.flag_wuhan_data_v2 = (this.chosen_city == "Wuhan") &&(start_date > change_date_wh)
      },
      getCampaignDate(){
        let tmp_info = JSON.parse(sessionStorage.getItem('Data_Information'))
        let CampaignDate = tmp_info.date
        return CampaignDate

      },
      fillData_Info() {
        let tmp_info = JSON.parse(sessionStorage.getItem('Data_Information'))
        Object.assign(this.information, tmp_info)
        if (tmp_info.duration !=null){
          this.information.value_duration = tmp_info.duration
        }else if (tmp_info.campaignDuration != null){
          this.information.value_duration = tmp_info.campaignDuration
          tmp_info.date = tmp_info.campaignDate
        }

        if (this.numberBit(tmp_info.date)==10){
          tmp_info.date = tmp_info.date*1000
        }
        let tmp = new Date(tmp_info.date)
        this.information.date = tmp.toISOString()
        let gender = this.information['data_audience'].value_gender
        let age = this.information['data_audience'].value_age
        let spend_power = this.information['data_audience'].value_spend_power
        let interest = this.information['data_audience'].value_interest
        let gender_options = this.options['audience_options']['gender_options']
        let age_options = this.options['audience_options']['age_options']
        let spend_power_options = this.options['audience_options']['spend_power_options']
        let interest_options = this.options['audience_options']['interest_options']
        
        this.poi_ba_value_selection_list = this.information['poi_ba_value_selection_list']
        let poi_ba_label_selection_list = this.information['poi_ba_label_selection_list']

        this.gender = this.changeDataToText(gender, gender_options)
        this.age = this.changeDataToText(age, age_options)
        this.spend_power = this.changeDataToText(spend_power, spend_power_options)
        this.interest = this.changeDataToText(interest, interest_options)
        this.poi = this.changeDataToText_poi(this.information['data_poi'])
        this.media_type = this.changeDataToText(this.information['data_media_rank'].value_media_format, this.options[
          'media_rank_options'].media_format_options)
        this.rank = this.changeDataToText(this.information['data_media_rank'].value_rank, this.options[
          'media_rank_options'].rank_options)
        if (this.rank !="") this.ifRank=true
        
        this.campaignDate =this.information.date;
        this.campaignDuration = this.information.value_duration;
        this.poi_ba_label_selection_list = this.changeDataToText_PoiSearch(poi_ba_label_selection_list)
      },
      fillData_Map(isFromHistory) {
        let data = JSON.parse(sessionStorage.getItem('Data_Map'));
        this.estimated_cost = data.estimated_cost
        this.CPM = data.CPM
        this.adjusted_CPM = data.adjusted_CPM
        this.media_cost = data.media_cost
        this.production_cost = data.production_cost
        this.proposal_cost = data.proposal_cost
        this.media_discount = data.media_discount
        this.production_discount = data.production_discount
        this.proposal_discount = data.proposal_discount
        this.media_discount_cost = data.media_discount_cost
        this.production_discount_cost = data.production_discount_cost
        this.proposal_discount_cost = data.proposal_discount_cost
        
        this.media_CPM = data.media_CPM
        this.adjusted_media_CPM = data.adjusted_media_CPM
        this.discount_media_CPM = data.discount_media_CPM
        this.discount_adjusted_media_CPM = data.discount_adjusted_media_CPM
        this.proposal_CPM = data.proposal_CPM
        this.adjusted_proposal_CPM = data.adjusted_proposal_CPM
        this.discount_proposal_CPM = data.discount_proposal_CPM
        this.discount_adjusted_proposal_CPM = data.discount_adjusted_proposal_CPM

        this.pricingMode = data.pricingMode
  
        this.indexChartData = data.indexChartData
        this.rankChartData = data.rankChartData
        this.rankChartOptions.xaxis.categories = data.rankChartCategories
        this.$refs.rankchart.updateOptions(this.rankChartOptions)

        
        if (!isFromHistory) {
          this.ifShowViewed = JSON.parse(sessionStorage.getItem('ifShowViewed'))

          this.transDataOfTableData(this.tableData, data.tableData)
        }
        
      },

      fillData() {
        let impression_total_arr = JSON.parse(sessionStorage.getItem('impression_total_arr'))
        let impression_average = 0
        let cpm_arr = JSON.parse(sessionStorage.getItem('cpm_arr'))
        let cpm_average = 0
        let adjusted_impression_arr = JSON.parse(sessionStorage.getItem('adjusted_impression_arr'))
        let adjusted_impression_average = 0
        let adjusted_cpm_arr = JSON.parse(sessionStorage.getItem('adjusted_cpm_arr'))
        let adjusted_cpm_average = 0
        
        let ifShowViewed

        let gender_female = []
        let gender_male = []
        let age_18_24 = []
        let age_25_34 = []
        let age_35_44 = []
        let age_45_54 = []
        let age_55_64 = []
        let spend_power_low = []
        let spend_power_medium = []
        let spend_power_high = []
        let spend_power_low_income = []
        let spend_power_middle_income = []
        let spend_power_middle_class = []
        let spend_power_upper_middle_class = []
        let spend_power_rich = []
        let spend_power_super_rich = []
        let interest_number_of_audience = []
        let interest_banking_finance = []
        let interest_beauty_healthcare = []
        let interest_cars_it = []
        let interest_lifestyle_catering = []
        let interest_online_shopping_social_media = []
        let interest_online_training_education = []
        let interest_video_entertainment = []
        let interest_travel_tourism = []
        
        let sum_gender_female = 0
        let sum_gender_male = 0
        let sum_age_18_24 = 0
        let sum_age_25_34 = 0
        let sum_age_35_44 = 0
        let sum_age_45_54 = 0
        let sum_age_55_64 = 0
        let sum_spend_power_low = 0
        let sum_spend_power_medium = 0
        let sum_spend_power_high = 0
        let sum_spend_power_low_income = 0
        let sum_spend_power_middle_income = 0
        let sum_spend_power_middle_class = 0
        let sum_spend_power_upper_middle_class = 0
        let sum_spend_power_rich = 0
        let sum_spend_power_super_rich = 0
        let sum_interest_number_of_audience = 0
        let sum_interest_banking_finance = 0
        let sum_interest_beauty_healthcare = 0
        let sum_interest_cars_it = 0
        let sum_interest_lifestyle_catering = 0
        let sum_interest_online_shopping_social_media = 0
        let sum_interest_online_training_education = 0
        let sum_interest_video_entertainment = 0
        let sum_interest_travel_tourism = 0

        let tableDataCommercial = JSON.parse(sessionStorage.getItem('tableDataCommercial'))
        for (let ele in tableDataCommercial) {
          gender_female.push(tableDataCommercial[ele]['gender_female'])
          gender_male.push(tableDataCommercial[ele]['gender_male'])
          age_18_24.push(tableDataCommercial[ele]['age_18_24'])
          age_25_34.push(tableDataCommercial[ele]['age_25_34'])
          age_35_44.push(tableDataCommercial[ele]['age_35_44'])
          age_45_54.push(tableDataCommercial[ele]['age_45_54'])
          age_55_64.push(tableDataCommercial[ele]['age_55_64'])
          spend_power_low.push(tableDataCommercial[ele]['spend_power_low'])
          spend_power_medium.push(tableDataCommercial[ele]['spend_power_medium'])
          spend_power_high.push(tableDataCommercial[ele]['spend_power_high'])
          spend_power_low_income.push(tableDataCommercial[ele]['spend_power_low_income'])
          spend_power_middle_income.push(tableDataCommercial[ele]['spend_power_middle_income'])
          spend_power_middle_class.push(tableDataCommercial[ele]['spend_power_middle_class'])
          spend_power_upper_middle_class.push(tableDataCommercial[ele]['spend_power_upper_middle_class'])
          spend_power_rich.push(tableDataCommercial[ele]['spend_power_rich'])
          spend_power_super_rich.push(tableDataCommercial[ele]['spend_power_super_rich'])
          interest_number_of_audience.push(tableDataCommercial[ele]['interest_number_of_audience'])
          interest_banking_finance.push(tableDataCommercial[ele]['interest_banking_finance'])
          interest_beauty_healthcare.push(tableDataCommercial[ele]['interest_beauty_healthcare'])
          interest_cars_it.push(tableDataCommercial[ele]['interest_cars_it'])
          interest_lifestyle_catering.push(tableDataCommercial[ele]['interest_lifestyle_catering'])
          interest_online_shopping_social_media.push(tableDataCommercial[ele]['interest_online_shopping_social_media'])
          interest_online_training_education.push(tableDataCommercial[ele]['interest_online_training_education'])
          interest_video_entertainment.push(tableDataCommercial[ele]['interest_video_entertainment'])
          interest_travel_tourism.push(tableDataCommercial[ele]['interest_travel_tourism'])

          sum_gender_female = Number(sum_gender_female) + Number(tableDataCommercial[ele]['gender_female'])
          sum_gender_male = Number(sum_gender_male) + Number(tableDataCommercial[ele]['gender_male'])
          sum_age_18_24 = Number(sum_age_18_24) + Number(tableDataCommercial[ele]['age_18_24'])
          sum_age_25_34 = Number(sum_age_25_34) + Number(tableDataCommercial[ele]['age_25_34'])
          sum_age_35_44 = Number(sum_age_35_44) + Number(tableDataCommercial[ele]['age_35_44'])
          sum_age_45_54 = Number(sum_age_45_54) + Number(tableDataCommercial[ele]['age_45_54'])
          sum_age_55_64 = Number(sum_age_55_64) + Number(tableDataCommercial[ele]['age_55_64'])
          sum_spend_power_low = Number(sum_spend_power_low) + Number(tableDataCommercial[ele]['spend_power_low'])
          sum_spend_power_medium = Number(sum_spend_power_medium) + Number(tableDataCommercial[ele]['spend_power_medium'])
          sum_spend_power_high = Number(sum_spend_power_high) + Number(tableDataCommercial[ele]['spend_power_high'])
          sum_spend_power_low_income = Number(sum_spend_power_low_income) + Number(tableDataCommercial[ele]['spend_power_low_income'])
          sum_spend_power_middle_income = Number(sum_spend_power_middle_income) + Number(tableDataCommercial[ele]['spend_power_middle_income'])
          sum_spend_power_middle_class = Number(sum_spend_power_middle_class) + Number(tableDataCommercial[ele]['spend_power_middle_class'])
          sum_spend_power_upper_middle_class = Number(sum_spend_power_upper_middle_class) + Number(tableDataCommercial[ele]['spend_power_upper_middle_class'])
          sum_spend_power_rich = Number(sum_spend_power_rich) + Number(tableDataCommercial[ele]['spend_power_rich'])
          sum_spend_power_super_rich = Number(sum_spend_power_super_rich) + Number(tableDataCommercial[ele]['spend_power_super_rich'])
          sum_interest_number_of_audience = 0
          sum_interest_banking_finance = Number(sum_interest_banking_finance) + Number(tableDataCommercial[ele]['interest_banking_finance'])
          sum_interest_beauty_healthcare = Number(sum_interest_beauty_healthcare) + Number(tableDataCommercial[ele]['interest_beauty_healthcare'])
          sum_interest_cars_it = Number(sum_interest_cars_it) + Number(tableDataCommercial[ele]['interest_cars_it'])
          sum_interest_lifestyle_catering = Number(sum_interest_lifestyle_catering) + Number(tableDataCommercial[ele]['interest_lifestyle_catering'])
          sum_interest_online_shopping_social_media = Number(sum_interest_online_shopping_social_media) + Number(tableDataCommercial[ele]['interest_online_shopping_social_media'])
          sum_interest_online_training_education = Number(sum_interest_online_training_education) + Number(tableDataCommercial[ele]['interest_online_training_education'])
          sum_interest_video_entertainment = Number(sum_interest_video_entertainment) + Number(tableDataCommercial[ele]['interest_video_entertainment'])
          sum_interest_travel_tourism = Number(sum_interest_travel_tourism) + Number(tableDataCommercial[ele]['interest_travel_tourism'])
        }


        if (this.dataHistory != null && this.dataHistory != ""){
          impression_total_arr =[]
          cpm_arr=[]
          adjusted_impression_arr = []
          adjusted_cpm_arr = []
          ifShowViewed = this.dataHistory.ifShowViewed
          for (let ele in this.dataHistory.bus_line) {
            /*
            bus_id_arr.push(response.data[ele]['bus_id']);
            reach_arr.push(response.data[ele]['reach']);
            frequency_arr.push(response.data[ele]['frequency']); */
            let impression_val = this.delcommafy(this.dataHistory.bus_line[ele]['impression_total'])
            let adjusted_impression_val = this.delcommafy(this.dataHistory.bus_line[ele]['adjusted_impression'])
            impression_total_arr.push(impression_val);
            /* price_arr.push(response.data[ele]['price']); */
            cpm_arr.push(Number(this.dataHistory.bus_line[ele]['CPM']));
            adjusted_impression_arr.push(adjusted_impression_val)
            adjusted_cpm_arr.push(Number(this.dataHistory.bus_line[ele]['adjusted_CPM']))

            gender_female.push(this.dataHistory.bus_line[ele]['gender_female'])
            gender_male.push(this.dataHistory.bus_line[ele]['gender_male'])
            age_18_24.push(this.dataHistory.bus_line[ele]['age_18_24'])
            age_25_34.push(this.dataHistory.bus_line[ele]['age_25_34'])
            age_35_44.push(this.dataHistory.bus_line[ele]['age_35_44'])
            age_45_54.push(this.dataHistory.bus_line[ele]['age_45_54'])
            age_55_64.push(this.dataHistory.bus_line[ele]['age_55_64'])
            spend_power_low.push(this.dataHistory.bus_line[ele]['spend_power_low'])
            spend_power_medium.push(this.dataHistory.bus_line[ele]['spend_power_medium'])
            spend_power_high.push(this.dataHistory.bus_line[ele]['spend_power_high'])
            interest_number_of_audience.push(this.dataHistory.bus_line[ele]['interest_number_of_audience'])
            interest_banking_finance.push(this.dataHistory.bus_line[ele]['interest_banking_finance'])
            interest_beauty_healthcare.push(this.dataHistory.bus_line[ele]['interest_beauty_healthcare'])
            interest_cars_it.push(this.dataHistory.bus_line[ele]['interest_cars_it'])
            interest_lifestyle_catering.push(this.dataHistory.bus_line[ele]['interest_lifestyle_catering'])
            interest_online_shopping_social_media.push(this.dataHistory.bus_line[ele]['interest_online_shopping_social_media'])
            interest_online_training_education.push(this.dataHistory.bus_line[ele]['interest_online_training_education'])
            interest_video_entertainment.push(this.dataHistory.bus_line[ele]['interest_video_entertainment'])
            interest_travel_tourism.push(this.dataHistory.bus_line[ele]['interest_travel_tourism'])
          }
          
        }else{
          //ifShowViewed = data.ifShowViewed
          ifShowViewed = JSON.parse(sessionStorage.getItem('ifShowViewed'))
        }
        
        if (impression_total_arr){
          impression_average = Math.round(this.average(impression_total_arr))
          sessionStorage.setItem('impression_total_arr_avg', JSON.stringify(impression_average));
        }else{
          impression_average = JSON.parse(sessionStorage.getItem('impression_total_arr_avg'))
        }
        if(cpm_arr){
          cpm_average = Number(this.average(cpm_arr).toFixed(2));
          sessionStorage.setItem('cpm_arr_avg', JSON.stringify(cpm_average));
        }else{
          cpm_average = JSON.parse(sessionStorage.getItem('cpm_arr_avg'))
        }
        if (adjusted_impression_arr){
          adjusted_impression_average = Math.round(this.average(adjusted_impression_arr))
          sessionStorage.setItem('adjusted_impression_arr_avg', JSON.stringify(adjusted_impression_average));
        }else{
          adjusted_impression_average = JSON.parse(sessionStorage.getItem('adjusted_impression_arr_avg'))
        }
        if(adjusted_cpm_arr){
          adjusted_cpm_average = Number(this.average(adjusted_cpm_arr).toFixed(2));
          sessionStorage.setItem('adjusted_cpm_arr_avg', JSON.stringify(adjusted_cpm_average));
        }else{
          adjusted_cpm_average = JSON.parse(sessionStorage.getItem('adjusted_cpm_arr_avg'))
        }
        let bus_id_arr = []
        // 兼容性处理：优先使用 bus_name，如果没有则回退到 bus_id
        if (this.ifSave){
          // 从历史记录加载时，检查是否有 bus_name 可用
          if (this.dataHistory.bus_line && this.dataHistory.bus_line.length > 0) {
            bus_id_arr = []
            for (let ele of this.dataHistory.bus_line) {
              bus_id_arr.push(ele.bus_name || ele.bus_id)
            }
          } else {
            bus_id_arr = this.dataHistory.bus_id_arr
          }
        }else{
          bus_id_arr = JSON.parse(sessionStorage.getItem('bus_id_arr'))
          // 如果 sessionStorage 中没有或格式不对，尝试从 tableDataCommercial 获取
          if (!bus_id_arr || bus_id_arr.length === 0) {
            let tableDataCommercial = JSON.parse(sessionStorage.getItem('tableDataCommercial'))
            if (tableDataCommercial && tableDataCommercial.length > 0) {
              bus_id_arr = []
              for (let ele of tableDataCommercial) {
                bus_id_arr.push(ele.bus_name || ele.bus_id)
              }
            }
          }
        }

        if (ifShowViewed){
          this.impression_datasets = [{
            label: this.$t('message.Viewed_Impression'),
            backgroundColor: '#039BE599',
            borderColor: '#039BE5',
            borderWidth: 1,
            hoverBackgroundColor: '#039BE5',
            barPercentage: 0.8,
            data: impression_total_arr
          },
          {
            label: this.$t('message.Viewed_Impression(Audience)'),
            backgroundColor: '#80DEEA',
            borderColor: '#00ACC1',
            borderWidth: 1,
            hoverBackgroundColor: '#00ACC1',
            barPercentage: 0.8,
            data: adjusted_impression_arr
          }]

          this.impression_annotations = [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: impression_average,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + parseInt(impression_average).toLocaleString(),
                enabled: true,
                fontSize: screen.width>=768 ? 15:12,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
            },
            {
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: adjusted_impression_average,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + parseInt(adjusted_impression_average).toLocaleString(),
                enabled: true,
                fontSize: screen.width>=768 ? 15:12,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
            }]
          
          this.cpm_datasets = [{
            label: this.$t('message.CPM'),
            backgroundColor: '#039BE599',
            borderColor: '#039BE5',
            borderWidth: 1,
            hoverBackgroundColor: '#039BE5',
            barPercentage: 0.8,
            data: cpm_arr
          },
          {
            label: this.$t('message.CPM_Target_Audience_Based'),
            backgroundColor: '#80DEEA',
            borderColor: '#00ACC1',
            borderWidth: 1,
            hoverBackgroundColor: '#00ACC1',
            barPercentage: 0.8,
            data: adjusted_cpm_arr
          }]
          
          this.cpm_annotations = [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.CPM,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + this.CPM,
                enabled: true,
                fontSize: 16,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
            },
              {
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.adjusted_CPM,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + this.adjusted_CPM,
                enabled: true,
                fontSize: 16,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              }
            }]
        }else{
          this.impression_datasets = [{
            label: this.$t('message.Viewed_Impression'),
            backgroundColor: '#039BE599',
            borderColor: '#039BE5',
            borderWidth: 1,
            hoverBackgroundColor: '#039BE5',
            barPercentage: 0.8,
            data: impression_total_arr
          }]
          this.impression_annotations = [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: impression_average,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + (impression_average).toLocaleString(),
                enabled: true,
                fontSize: screen.width>=768 ? 15:12,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              }
            }]
          
          this.cpm_datasets = [{
            label: this.$t('message.CPM'),
            backgroundColor: '#039BE599',
            borderColor: '#039BE5',
            borderWidth: 1,
            hoverBackgroundColor: '#039BE5',
            barPercentage: 0.8,
            data: cpm_arr
          }]
          this.cpm_annotations = [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.CPM,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + this.CPM,
                enabled: true,
                fontSize: 16,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
            }]
        }

        this.datacollection_impression_total = {
          labels: bus_id_arr,
          datasets: this.impression_datasets
        };
        this.datacollection_cpm = {
          labels: bus_id_arr,
          datasets: this.cpm_datasets
        };
        this.chart_options_impression_total = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Viewed_Impression_chart'),
            fontSize: screen.width >= 768 ? 23:16,
            padding: screen.width >= 768 ? 40:10,
            lineHeight: 0.2
          },
          legend: {
            display: true,
          },
          gridLines: {
            offsetGridLines: false
          },
          scaleLabel:"<%=value%>",

          scales: {
            yAxes: [{
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: screen.width>=768 ? 15 : 12,
                precision: 10,
                callback: function(value, index, values) {
                  //return value/1000 + 'k';
                  let result = "";
                  if (value < 1000) {
                    result = value
                  }
                  else if (value >= 1000000000) {
                    result = (value / 1000000000).toFixed(1).toString().replace(".0","") + "B"
                  }
                  else if (value >= 1000000) {
                    result = (value / 1000000).toFixed(1).toString().replace(".0","") + "M"
                  }
                  else {
                    result = (value / 1000).toFixed(1).toString().replace(".0","") + "K"
                  }
                  return result
                }
              }
            }],
            xAxes: [{
              ticks: {
                display: true,
                fontSize: screen.width>=768 ? 15 : 12,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          },
          annotation: {
            annotations: this.impression_annotations
          },
          responsive: true,
          maintainAspectRatio: false
        };
        this.chart_options_cpm = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.CPM_chart'),
            fontSize: screen.width >= 768 ? 23:16,
            padding: screen.width >= 768 ? 40:10,
            lineHeight: 0.2
          },
          legend: {
            display: true,
          },
          gridLines: {
            offsetGridLines: false
          },

          scales: {
            yAxes: [{
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15
              }
            }],
            xAxes: [{
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          },
          annotation: {
            annotations: this.cpm_annotations
          }
        };

        this.datacollection_gender = {
          labels: bus_id_arr,
          datasets: [{
            label: this.$t('message.gender_female'),
            backgroundColor: '#F48FB1',
            //borderColor: '#039BE5',
            //borderWidth: 1,
            //hoverBackgroundColor: '#039BE5',
            //barPercentage: 0.8,
            data: gender_female
          },
          { 
            label: this.$t('message.gender_male'),
            backgroundColor: '#42A5F5',
            data:gender_male
          }]
        }
        this.datacollection_age = {
          labels: bus_id_arr,
          datasets: [{
            label: this.$t('message.age_18_24'),
            backgroundColor: '#B2DFDB',
            data: age_18_24
          },
          { 
            label: this.$t('message.age_25_34'),
            backgroundColor: '#4DB6AC',
            data:age_25_34
          },
          {
            label: this.$t('message.age_35_44'),
            backgroundColor: '#009688',
            data: age_35_44
          },
          { 
            label: this.$t('message.age_45_54'),
            backgroundColor: '#00796B',
            data:age_45_54
          },
          { 
            label: this.$t('message.age_55_64'),
            backgroundColor: '#00695C',
            data:age_55_64
          }
          ]
        }
        if (this.chosen_city == "Shenzhen" || this.chosen_city ==  "Chongqing" || this.chosen_city ==  "Chengdu" || this.flag_nanjing_data_v2 || this.flag_wuhan_data_v2 || this.chosen_city ==  "Shanghai")
          this.datacollection_spend_power = {
            labels: bus_id_arr,
            datasets: [{
              label: this.$t('message.spend_power_low_income'),
              backgroundColor: '#FFF3E0',
              data: spend_power_low_income
            },
            { 
              label: this.$t('message.spend_power_middle_income'),
              backgroundColor: '#FFCC80',
              data:spend_power_middle_income
            },
            {
              label: this.$t('message.spend_power_middle_class'),
              backgroundColor: '#FFA726',
              data: spend_power_middle_class
            },
            {
              label: this.$t('message.spend_power_upper_middle_class'),
              backgroundColor: '#FB8C00',
              data: spend_power_upper_middle_class
            },
            {
              label: this.$t('message.spend_power_rich'),
              backgroundColor: '#EF6C00',
              data: spend_power_rich
            },
            {
              label: this.$t('message.spend_power_super_rich'),
              backgroundColor: '#E65100',
              data: spend_power_super_rich
            }]
          }
        else
          this.datacollection_spend_power = {
            labels: bus_id_arr,
            datasets: [{
              label: this.$t('message.spend_power_low'),
              backgroundColor: '#FFB74D',
              data: spend_power_low
            },
            { 
              label: this.$t('message.spend_power_medium'),
              backgroundColor: '#FF9800',
              data:spend_power_medium
            },
            {
              label: this.$t('message.spend_power_high'),
              backgroundColor: '#F57C00',
              data: spend_power_high
            }]
          }
          
        this.datacollection_interest = {
          labels: bus_id_arr,
          datasets: [{
            label: this.$t('message.interest_banking_finance'),
            backgroundColor: '#3949AB',
            data: interest_banking_finance
          },
          { 
            label: this.$t('message.interest_beauty_healthcare'),
            backgroundColor: '#1E88E5',
            data:interest_beauty_healthcare
          },
          {
            label: this.$t('message.interest_cars_it'),
            backgroundColor: '#00ACC1',
            data: interest_cars_it
          },
          { 
            label: this.$t('message.interest_lifestyle_catering'),
            backgroundColor: '#00897B',
            data:interest_lifestyle_catering
          },
          { 
            label: this.$t('message.interest_online_shopping_social_media'),
            backgroundColor: '#7CB342',
            data:interest_online_shopping_social_media
          },
          { 
            label: this.$t('message.interest_online_training_education'),
            backgroundColor: '#C0CA33',
            data:interest_online_training_education
          },
          { 
            label: this.$t('message.interest_video_entertainment'),
            backgroundColor: '#FFB300',
            data:interest_video_entertainment
          },
          { 
            label: this.$t('message.interest_travel_tourism'),
            backgroundColor: '#F4511E',
            data:interest_travel_tourism
          }]
        }
        this.chart_options_gender = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Detailed_distribution_gender'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          scales: 
          {
            yAxes: [{
              stacked: true,
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15,
                callback: function(value, index, values) {
                        return value/1000 + 'k';
                    }
              }
            }],
            xAxes: [{
              stacked: true,
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          }
        }
        this.chart_options_age = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Detailed_distribution_age'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          scales: 
          {
            yAxes: [{
              stacked: true,
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15,
                callback: function(value, index, values) {
                        return value/1000 + 'k';
                    }
              }
            }],
            xAxes: [{
              stacked: true,
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          }
        }
        this.chart_options_spend_power = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Detailed_distribution_spend_power'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          scales: 
          {
            yAxes: [{
              stacked: true,
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15,
                callback: function(value, index, values) {
                        return value/1000 + 'k';
                    }
              }
            }],
            xAxes: [{
              stacked: true,
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          }
        }
        this.chart_options_interest = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Detailed_distribution_interest'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          scales: 
          {
            yAxes: [{
              stacked: true,
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15,
                callback: function(value, index, values) {
                        return value/1000 + 'k';
                    }
              }
            }],
            xAxes: [{
              stacked: true,
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          }
        }
        
        this.seriesGender = [sum_gender_female,sum_gender_male]
        this.seriesAge = [sum_age_18_24,sum_age_25_34,sum_age_35_44,sum_age_45_54,sum_age_55_64]
        if ((this.chosen_city == 'Shenzhen' || this.chosen_city == "Chongqing" || this.chosen_city ==  "Chengdu"||this.flag_nanjing_data_v2|| this.flag_wuhan_data_v2|| this.chosen_city ==  "Shanghai")) {
          this.seriesSpendPower = [sum_spend_power_low_income,sum_spend_power_middle_income,sum_spend_power_middle_class,sum_spend_power_upper_middle_class,sum_spend_power_rich,sum_spend_power_super_rich]
        }
        else {
          this.seriesSpendPower = [sum_spend_power_low,sum_spend_power_medium,sum_spend_power_high]
        }
        
        this.seriesInterest = [sum_interest_banking_finance,sum_interest_beauty_healthcare,sum_interest_cars_it,sum_interest_lifestyle_catering,sum_interest_online_shopping_social_media,sum_interest_online_training_education,sum_interest_video_entertainment,sum_interest_travel_tourism]

        this.chartOptionsGender = {
          title: {
            text: this.$t('message.Overall_distribution_gender'),
            align: 'center',
            margin: 40,
            style: {
              fontSize: '23px',
              fontWeight: 'bold',
              fontFamily: undefined,
              color: '#666666'
            },
          },
          colors: ['#F48FB1','#42A5F5'],
          labels: [this.$t('message.gender_female'),this.$t('message.gender_male')],
          dataLabels: {
            style: {
              colors: ["#FFFFFF"],
            }
          },
          legend: {
            show: true,
            position:'top',
            horizontalAlign: 'center',
            offsetY: -10,
          },
          plotOptions: {
            pie: {
              donut: {
                size: '50%'
              }
            }
          }
        }
        this.chartOptionsAge = {
          title: {
            text: this.$t('message.Overall_distribution_age'),
            align: 'center',
            margin: 40,
            style: {
              fontSize: '23px',
              fontWeight: 'bold',
              fontFamily: undefined,
              color: '#666666'
            },
          },
          colors: ['#B2DFDB','#4DB6AC','#009688','#00796B','#00695C'],
          labels: [this.$t('message.age_18_24'),this.$t('message.age_25_34'),this.$t('message.age_35_44'),this.$t('message.age_45_54'),this.$t('message.age_55_64')],
          dataLabels: {
            style: {
              colors: ["#FFFFFF"],
            }
          },
          legend: {
            show: true,
            position:'top',
            horizontalAlign: 'center',
            offsetY: -10,
          },
          plotOptions: {
            pie: {
              donut: {
                size: '50%'
              }
            }
          }
        }
        if ((this.chosen_city == 'Shenzhen' || this.chosen_city == "Chongqing" || this.chosen_city ==  "Chengdu" ||this.flag_nanjing_data_v2|| this.flag_wuhan_data_v2|| this.chosen_city ==  "Shanghai" )) {
          this.chartOptionsSpendPower = {
            title: {
              text: this.$t('message.Overall_distribution_spend_power'),
              align: 'center',
              margin: 40,
              style: {
                fontSize: '23px',
                fontWeight: 'bold',
                fontFamily: undefined,
                color: '#666666'
              },
            },
            colors: ['#FFF3E0','#FFCC80','#FFA726','#FB8C00','#EF6C00','#E65100'],
            labels: [this.$t('message.spend_power_low_income'),this.$t('message.spend_power_middle_income'),this.$t('message.spend_power_middle_class'),this.$t('message.spend_power_upper_middle_class'),this.$t('message.spend_power_rich'),this.$t('message.spend_power_super_rich')],
            dataLabels: {
              style: {
                colors: ["#FFFFFF"],
              }
            },
            legend: {
              show: true,
              position:'top',
              horizontalAlign: 'center',
              offsetY: -10,
            },
            plotOptions: {
              pie: {
                donut: {
                  size: '50%'
                }
              }
            }
          }
        }
        else {
          this.chartOptionsSpendPower = {
            title: {
              text: this.$t('message.Overall_distribution_spend_power'),
              align: 'center',
              margin: 40,
              style: {
                fontSize: '23px',
                fontWeight: 'bold',
                fontFamily: undefined,
                color: '#666666'
              },
            },
            colors: ['#FFB74D','#FF9800','#F57C00'],
            labels: [this.$t('message.spend_power_low'),this.$t('message.spend_power_medium'),this.$t('message.spend_power_high')],
            dataLabels: {
              style: {
                colors: ["#FFFFFF"],
              }
            },
            legend: {
              show: true,
              position:'top',
              horizontalAlign: 'center',
              offsetY: -10,
            },
            plotOptions: {
              pie: {
                donut: {
                  size: '50%'
                }
              }
            }
          }
        }
        this.chartOptionsInterest = {
          title: {
            text: this.$t('message.Overall_distribution_interest'),
            align: 'center',
            margin: 40,
            style: {
              fontSize: '23px',
              fontWeight: 'bold',
              fontFamily: undefined,
              color: '#666666'
            },
          },
          colors: ['#3949AB','#1E88E5','#00ACC1','#00897B','#7CB342', '#C0CA33','#FFB300','#F4511E'],
          labels: [this.$t('message.interest_banking_finance'),this.$t('message.interest_beauty_healthcare'),this.$t('message.interest_cars_it'),this.$t('message.interest_lifestyle_catering'),this.$t('message.interest_online_shopping_social_media'),this.$t('message.interest_online_training_education'),this.$t('message.interest_video_entertainment'),this.$t('message.interest_travel_tourism')],
          dataLabels: {
            style: {
              colors: ["#FFFFFF"],
            }
          },
          legend: {
            show: true,
            position:'top',
            horizontalAlign: 'center',
            offsetY: -10,
          },
          plotOptions: {
            pie: {
              donut: {
                size: '50%'
              }
            }
          }
        }
      },

      changeDataToText_poi(poi) {
        let str = "";
        if (poi.checked_business == true) {
          str = str + this.$t('message.BUSINESS') + ' ';
        }
        if (poi.checked_entertainment == true) {
          str = str + this.$t('message.ENTERTAINEMENT') + ' ';
        }
        if (poi.checked_living == true) {
          str = str + this.$t('message.LIVING') + ' ';
        }
        if (poi.checked_trip == true) {
          str = str + this.$t('message.TRIP');
        }
        return str;
      },

      changeDataToText(data, options) {
        let obj = "";
        if (this.$i18n.locale == 'en'){
          if (typeof(data) == "number") {
            for (let i = 0; i < options.length; i++) {
              if (Number(options[i].value) == data) {
                obj = obj + options[i].label;
              }
            }
          } else if (typeof(data) == "object") {
            if (data.length > 1) {
              data = data.sort();
            }
          
            for (let d in data) {
              for (let op in options) {
                if (Number(data[d]) == Number(options[op].value)) {
                  obj = obj + String(options[op].label) + ' ';
                }
              }
            }
          }
        }else if (this.$i18n.locale == 'cn'){
          if (typeof(data) == "number") {
            for (let i = 0; i < options.length; i++) {
              if (Number(options[i].value) == data) {
                obj = obj + options[i].label_cn;
              }
            }
          } else if (typeof(data) == "object") {
            if (data.length > 1) {
              data = data.sort();
            }
          
            for (let d in data) {
              for (let op in options) {
                if (Number(data[d]) == Number(options[op].value)) {
                  obj = obj + String(options[op].label_cn) + ' ';
                }
              }
            }
          }
        }
        
        
        return obj;
      },

      changeDataToText_PoiSearch(poi_ba_label_selection_list){
          let poi_ba_label_selection_list_text = ''
          for (let index in poi_ba_label_selection_list){
            poi_ba_label_selection_list_text = poi_ba_label_selection_list_text + poi_ba_label_selection_list[index] + ' '
          }
          return poi_ba_label_selection_list_text
      },
      
      getRandomInt() {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
      average(numbers) {
        var total = 0,
          i;
        for (i = 0; i < numbers.length; i += 1) {
          total += numbers[i];
        }
        return total / numbers.length;
      },
      modifyInfo() {
        this.$router.push({
          path: '/information',
          query: {
            chosen_city: this.chosen_city
          }
        });
      },
      leftRight({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (columnIndex === 0) {
          return 'font-weight:700';
        } else if (columnIndex === 1) {
          return 'font-size:25px';
        }
      },

      exportAsPDF() {
        this.exportType = 'PDF'
        this.exportTypeSelector()
      },

      async exportTypeSelector(){
        switch(this.exportType){
          case '':
            this.$message(this.$t('message.Please_select_file_type'))
            break;
          case 'PDF':
          
            // if (this.onSubmit()){
              // wait saveDate() finsh and return reference_id
              //await this.saveData()
              if (!this.reference_id)
                await this.messageSaveData()
              // wait getReportInfo() finsh and return created_by and bu_city
              if (this.reference_id && this.reference_id.length>0) {
                this.$refs.export_pdf.showDialog()
                await this.getReportInfo()
                let obj = {}
                obj.clientName = this.form.name
                obj.clientLogoImage = this.clientLogoImage
                obj.chosen_city = this.chosen_city
                obj.campaignDateTimestamp = this.campaignDate
                obj.campaignDuration = this.campaignDuration
                obj.tableData = this.tableData
                obj.gender = this.gender
                obj.age = this.age
                obj.spend_power = this.spend_power
                obj.interest = this.interest
                obj.poi = this.poi
                obj.media_type = this.media_type
                obj.tableDataCommercial = this.tableDataCommercial
                obj.reference_id = this.reference_id
                obj.createdBy = this.createdBy
                obj.team = this.team
                obj.ifShowViewed = this.ifShowViewed
                obj.poi_ba_label_selection_list = this.poi_ba_label_selection_list
                obj.totalNearbyBusNumber = this.totalNearbyBusNumber
                
                obj.pricingMode = this.pricingMode
                obj.mediaCost = this.media_cost
                obj.prodCost = this.production_cost
                obj.proposalCost = this.proposal_cost
                obj.mediaDiscount = this.media_discount
                obj.prodDiscount = this.production_discount
                obj.proposalDiscount = this.proposal_discount
                obj.mediaDiscountCost = this.media_discount_cost
                obj.prodDiscountCost = this.production_discount_cost
                obj.proposalDiscountCost = this.proposal_discount_cost
                obj.mediaCPM = this.media_CPM
                obj.adjustedMediaCPM = this.adjusted_media_CPM
                obj.discountMediaCPM = this.discount_media_CPM
                obj.discountAdjustedMediaCPM = this.discount_adjusted_media_CPM
                obj.proposalCPM = this.proposal_CPM
                obj.adjustedProposalCPM = this.adjusted_proposal_CPM
                obj.discountProposalCPM = this.discount_proposal_CPM
                obj.discountAdjustedProposalCPM = this.discount_adjusted_proposal_CPM
                obj.logoImageRatioWH = this.logoImageRatioWH
                //this.getPdf(obj)
                this.$refs.export_pdf.getPdf(obj)
                //this.getPdf(this.form.name,this.clientLogoImage,this.chosen_city,this.campaignDate,this.campaignDuration,this.tableData,this.media_cost,this.production_cost,this.proposal_cost,this.media_CPM,this.adjusted_media_CPM,this.proposal_CPM,this.adjusted_proposal_CPM,this.gender,this.age,this.spend_power,this.interest,this.poi,this.media_type,this.tableDataCommercial,this.reference_id,this.createdBy,this.team,this.ifShowViewed,this.poi_ba_label_selection_list,this.totalNearbyBusNumber)
              }
            //}
            break;
          case 'Excel':
          
            if (this.onSubmit()){
              this.getExcel()
            }
            break;
          case 'Hub Template':
          
            if (this.onSubmit()){
              this.getHubTemplateExcel()
            }
            break;
        }
      },


      getReportInfo() {
        let api_url = _global.serverSrc + '/check_proposal/?format=json';
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.reference_id = this.reference_id
        return this.$axios.post(api_url,obj)
          .then(response => {
            if (response != null) {
              let user_history = response.data.user_history
              this.createdBy = user_history.created_by
              this.team = user_history.bu_city
            }
          })
          .catch(e => {
          })
      },

      showBusLine(){
        this.$refs.mapf.clearMap();
        for (let ele in this.tableDataCommercial) {
          this.$refs.mapf.lineSearch(this.tableDataCommercial[ele].bus_name ? this.tableDataCommercial[ele].bus_name : this.tableDataCommercial[ele].bus_id.replace("line_", "") + "路",this.chosen_city);
        }
        this.getSelectedPoiLocation(this.poi_ba_value_selection_list,this.$refs.mapf)
      },

      changeDetailInfoView(){      
        if (this.dataHistory != null && this.dataHistory != ""){
          this.dataHistory.ifShowViewed = this.ifShowViewed
          sessionStorage.setItem('Data_History', JSON.stringify(this.dataHistory));
        }else{
          sessionStorage.setItem('ifShowViewed', JSON.stringify(this.ifShowViewed));
        }
        this.$router.go(0)
      },

      getSelectedPoiLocation(poi_list,mapf) {
        let api_url = _global.serverSrc + '/selected_poi_location/?format=json&chosen_city=' + this.chosen_city;
        let obj = {
          'email': JSON.parse(sessionStorage.getItem('User')),
          'poi_list': poi_list
        }
        this.$axios.post(api_url, obj)
            .then(response => {
              mapf.drawPoi(response.data.selected_poi_location)
            })
            .catch(e => {
          })
      },

      resizeHandler() {
        if (this.screenWidth != window.innerWidth) {
          this.screenWidth = window.innerWidth
          if (this.screenWidth >= 768) {
            this.chart_options_impression_total.title.fontSize = 23
            this.chart_options_impression_total.title.padding = 40
            this.chart_options_impression_total.scales.yAxes[0].ticks.fontSize = 15
            this.chart_options_impression_total.scales.xAxes[0].ticks.fontSize = 15
            for (let ele of this.chart_options_impression_total.annotation.annotations) {
              ele.label.fontSize = 15
            }
            this.chart_options_impression_total= {...this.chart_options_impression_total}
            //chart_options_cpm
            this.chart_options_cpm.title.fontSize = 23
            this.chart_options_cpm.title.padding = 40
            this.chart_options_cpm.scales.yAxes[0].ticks.fontSize = 15
            this.chart_options_cpm.scales.xAxes[0].ticks.fontSize = 15
            for (let ele of this.chart_options_cpm.annotation.annotations) {
              ele.label.fontSize = 15
            }
            this.chart_options_cpm= {...this.chart_options_cpm}
          }
          else {
            this.chart_options_impression_total.title.fontSize = 16
            this.chart_options_impression_total.title.padding = 10
            this.chart_options_impression_total.scales.yAxes[0].ticks.fontSize = 12
            this.chart_options_impression_total.scales.xAxes[0].ticks.fontSize = 12
            for (let ele of this.chart_options_impression_total.annotation.annotations) {
              ele.label.fontSize = 12
            }
            this.chart_options_impression_total= {...this.chart_options_impression_total}
            this.chart_options_cpm.title.fontSize = 16
            this.chart_options_cpm.title.padding = 10
            this.chart_options_cpm.scales.yAxes[0].ticks.fontSize = 12
            this.chart_options_cpm.scales.xAxes[0].ticks.fontSize = 12
            for (let ele of this.chart_options_cpm.annotation.annotations) {
              ele.label.fontSize = 12
            }
            this.chart_options_cpm= {...this.chart_options_cpm}
          }

          clearTimeout(this.timeoutId)
          this.timeoutId = setTimeout(()=>{
            this.showBusLine()
          },100)
        }
      },
    },
    watch: {
      localLang() {
        
        this.fillData_Info()
        this.fillTable()

        //update impression_total chart
        this.datacollection_impression_total.datasets[0].label = this.$t('message.Viewed_Impression')
        if (this.datacollection_impression_total.datasets[1]) {
          this.datacollection_impression_total.datasets[1].label = this.$t('message.Viewed_Impression(Audience)')
        }
        this.datacollection_impression_total = {...this.datacollection_impression_total}
        
        for (let ele of this.chart_options_impression_total.annotation.annotations){
          ele.label.content = this.$t('message.Average') + parseInt(ele.value).toLocaleString()
        }
        this.chart_options_impression_total.title.text = this.$t('message.Viewed_Impression_chart')
        this.chart_options_impression_total = {...this.chart_options_impression_total}
        
        //update impression_total chart
        this.datacollection_cpm.datasets[0].label = this.$t('message.CPM')
        if (this.datacollection_cpm.datasets[1]) {
          this.datacollection_cpm.datasets[1].label = this.$t('message.CPM_Target_Audience_Based')
        }
        this.datacollection_cpm = {...this.datacollection_cpm}
        
        for (let ele of this.chart_options_cpm.annotation.annotations){
          ele.label.content = this.$t('message.Average') + parseInt(ele.value).toLocaleString()
        }
        this.chart_options_cpm.title.text = this.$t('message.CPM_chart')
        this.chart_options_cpm = {...this.chart_options_cpm}

        //update gender chart
        this.chartOptionsGender.title.text = this.$t('message.Overall_distribution_gender')
        this.chartOptionsGender.labels = [this.$t('message.gender_female'),this.$t('message.gender_male')]
        if (this.$refs.donutGender)
          this.$refs.donutGender.updateOptions(this.chartOptionsGender)

        this.datacollection_gender.datasets[0].label = this.$t('message.gender_female')
        this.datacollection_gender.datasets[1].label = this.$t('message.gender_male')
        this.datacollection_gender = {...this.datacollection_gender}
        this.chart_options_gender.title.text = this.$t('message.Detailed_distribution_gender')
        this.chart_options_gender = {...this.chart_options_gender}

        //update age chart
        this.chartOptionsAge.title.text = this.$t('message.Overall_distribution_age')
        this.chartOptionsAge.labels = [this.$t('message.age_18_24'),this.$t('message.age_25_34'),this.$t('message.age_35_44'),this.$t('message.age_45_54'),this.$t('message.age_55_64')]
        if (this.$refs.donutAge)
          this.$refs.donutAge.updateOptions(this.chartOptionsAge)

        this.datacollection_age.datasets[0].label = this.$t('message.age_18_24')
        this.datacollection_age.datasets[1].label = this.$t('message.age_25_34')
        this.datacollection_age.datasets[2].label = this.$t('message.age_35_44')
        this.datacollection_age.datasets[3].label = this.$t('message.age_45_54')
        this.datacollection_age.datasets[4].label = this.$t('message.age_55_64')
        this.datacollection_age = {...this.datacollection_age}
        this.chart_options_age.title.text = this.$t('message.Detailed_distribution_age')
        this.chart_options_age = {...this.chart_options_age}

        //update spend_power chart
        this.chartOptionsSpendPower.title.text = this.$t('message.Overall_distribution_spend_power')
        if (this.chosen_city == 'Shenzhen' || this.chosen_city ==  "Chongqing" || this.chosen_city ==  "Chengdu"|| this.flag_nanjing_data_v2 || this.flag_wuhan_data_v2|| this.chosen_city ==  "Shanghai")
          this.chartOptionsSpendPower.labels = [this.$t('message.spend_power_low_income'),this.$t('message.spend_power_middle_income'),this.$t('message.spend_power_middle_class'),this.$t('message.spend_power_upper_middle_class'),this.$t('message.spend_power_rich'),this.$t('message.spend_power_super_rich')]
        else
          this.chartOptionsSpendPower.labels = [this.$t('message.spend_power_low'),this.$t('message.spend_power_medium'),this.$t('message.spend_power_high')]
        if (this.$refs.donutSpendPower)
          this.$refs.donutSpendPower.updateOptions(this.chartOptionsSpendPower)
        if (this.chosen_city == 'Shenzhen' || this.chosen_city == "Chongqing" || this.chosen_city ==  "Chengdu"||this.flag_nanjing_data_v2 || this.flag_wuhan_data_v2|| this.chosen_city ==  "Shanghai") {
          this.datacollection_spend_power.datasets[0].label = this.$t('message.spend_power_low_income')
          this.datacollection_spend_power.datasets[1].label = this.$t('message.spend_power_middle_income')
          this.datacollection_spend_power.datasets[2].label = this.$t('message.spend_power_middle_class')
          this.datacollection_spend_power.datasets[3].label = this.$t('message.spend_power_upper_middle_class')
          this.datacollection_spend_power.datasets[4].label = this.$t('message.spend_power_rich')
          this.datacollection_spend_power.datasets[5].label = this.$t('message.spend_power_super_rich')
        }
        else {
          this.datacollection_spend_power.datasets[0].label = this.$t('message.spend_power_low')
          this.datacollection_spend_power.datasets[1].label = this.$t('message.spend_power_medium')
          this.datacollection_spend_power.datasets[2].label = this.$t('message.spend_power_high')
        }
        this.datacollection_spend_power = {...this.datacollection_spend_power}
        this.chart_options_spend_power.title.text = this.$t('message.Detailed_distribution_spend_power')
        this.chart_options_spend_power = {...this.chart_options_spend_power}

        //update interest chart
        this.chartOptionsInterest.title.text = this.$t('message.Overall_distribution_interest')
        this.chartOptionsInterest.labels = [this.$t('message.interest_banking_finance'),this.$t('message.interest_beauty_healthcare'),this.$t('message.interest_cars_it'),this.$t('message.interest_lifestyle_catering'),this.$t('message.interest_online_shopping_social_media'),this.$t('message.interest_online_training_education'),this.$t('message.interest_video_entertainment'),this.$t('message.interest_travel_tourism')]
        if (this.$refs.donutInterest)
          this.$refs.donutInterest.updateOptions(this.chartOptionsInterest)

        this.datacollection_interest.datasets[0].label = this.$t('message.interest_banking_finance')
        this.datacollection_interest.datasets[1].label = this.$t('message.interest_beauty_healthcare')
        this.datacollection_interest.datasets[2].label = this.$t('message.interest_cars_it')
        this.datacollection_interest.datasets[3].label = this.$t('message.interest_lifestyle_catering')
        this.datacollection_interest.datasets[4].label = this.$t('message.interest_online_shopping_social_media')
        this.datacollection_interest.datasets[5].label = this.$t('message.interest_online_training_education')
        this.datacollection_interest.datasets[6].label = this.$t('message.interest_video_entertainment')
        this.datacollection_interest.datasets[7].label = this.$t('message.interest_travel_tourism')
        this.datacollection_interest = {...this.datacollection_interest}
        this.chart_options_interest.title.text = this.$t('message.Detailed_distribution_interest')
        this.chart_options_interest = {...this.chart_options_interest}

      }
    },
    destroyed() {
      window.removeEventListener("resize", this.resizeHandler);
    },
    components: {
      head_page,
      head_menu,
      export_pdf,
      BarChart,
      DoughnutChart,
      mapf,
      HorizontalBarChart,
      LineChart,
    },
  }
</script>

<style lang="scss" scoped>
  
  .level2_div2 {
    /* z-index:50; */
    /* background-color: #EFEFEF; */
    position: relative;
    background-color: white;
    /* height:300px;
			width:00px; */
    margin: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    /* border-style:ridge; */
    border-color: '#039BE5';
    border-width: 5px;
    margin-bottom: 40px;
    /* background-color: #E0E0E066; */
  }

  #inside_map {
    padding-top:50px;
    padding-bottom: 20px;
  }
  
  .info-list-style {
    background-color: white;
    background-clip: content-box;
    border-radius: 0;
  }

  .table-style{
    background-color: #EFEFEF;
    padding: 10px 20px;
  }

  /deep/ .el-form-item__label {
    font-size: 12px;
    margin-bottom: 0;
    line-height: 20px;
    color: #254A6E;
  }

  /deep/ .el-form-item__content {
    text-align: left;
    font-size: 12px;
    line-height: 20px;
    margin-left: 10px;
    color: #53ADBC;
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  /deep/ .el-divider--horizontal {
    margin: 5px 0;
  }

  /deep/ .el-collapse-item__content {
    padding-bottom: 10px;
  }

  /deep/ .el-collapse-item__header {
    height: 35px;
  }

  /deep/ .el-card__header {
    padding: 10px 20px;
  }

  /deep/ .el-card__body {
    padding: 10px 20px 15px 20px;
  }

  /deep/ .el-table__header-wrapper {
    .cell {
      word-break: break-word;
    }
  }
</style>
